{
  "it": {
    "labels": {
      "saved": "Salvato",
      "hangarShare": {
        "intro": "Crea un link segreto che mostra il tuo hangar e le sue statistiche a chiunque tu lo dia, anche quando il tuo hangar è privato. La tua lista dei desideri mantiene la propria impostazione.",
        "howTo": "Chiunque abbia questo link può vedere il tuo hangar. Rinnovalo per escludere chi ha il link attuale, oppure eliminalo per smettere di condividere."
      },
      "locationInput": {
        "linked": "Collegato a"
      },
      "galactapedia": "Galactapedia",
      "shopPage": {
        "all": "Tutto",
        "search": "Cerca in questo negozio",
        "categories": "Categorie",
        "sortName": "Nome",
        "sortPrice": "Prezzo",
        "emptyName": "articolo",
        "kind": "Negozio",
        "items": "Articoli",
        "facts": "Dati chiave",
        "place": "Luogo",
        "system": "Sistema",
        "carries": "Vende",
        "source": "Prezzi e disponibilità da UEX."
      },
      "location": {
        "missionsSample": "I conteggi coprono le prime %{shown} di %{total}.",
        "people": "Amici e flotta qui",
        "peopleFriend": "Amico",
        "peopleUnlisted": "altri %{count} non elencati",
        "systemUnavailable": "Impossibile caricare questo sistema.",
        "systemsUnavailable": "Impossibile caricare i sistemi.",
        "resourceKinds": {
          "ship_mineables": "Estraibili con nave",
          "hand_mineables": "Estraibili a mano",
          "ground_vehicle_mineables": "Estraibili con veicolo terrestre",
          "harvestables": "Raccoglibili",
          "creatures": "Creature"
        },
        "resources": "Risorse",
        "moonsBadge": "Lune",
        "planets": "Pianeti",
        "places": "Luoghi",
        "showFewer": "Mostra meno",
        "showAll": "Mostra tutti i %{count}",
        "elsewhere": "Altrove intorno a %{star}",
        "namesakes": "×%{count}",
        "lagrangePoints": "Punti di Lagrange",
        "inOrbit": "In orbita",
        "moons": {
          "one": "%{count} luna",
          "other": "%{count} lune"
        },
        "gateways": "Portali di salto",
        "jumpPoints": "Punti di salto",
        "notInGameYet": "Non ancora nel gioco",
        "jumpLegend": {
          "title": "Collegamenti di salto",
          "inGame": "Nel gioco",
          "temporary": "Temporaneo",
          "planned": "Previsto"
        },
        "systemStrip": "%{system}, dalla stella verso l'esterno",
        "allSystems": "Tutti i sistemi",
        "allPlaces": "Tutti i luoghi",
        "shops": "Negozi",
        "shopItems": {
          "one": "%{count} articolo",
          "other": "%{count} articoli"
        },
        "shopItemTypes": {
          "Model": "Nave",
          "ModelModule": "Modulo",
          "ModelPaint": "Verniciatura",
          "Component": "Componente",
          "Equipment": "Equipaggiamento",
          "Commodity": "Merce"
        },
        "bodyTypes": {
          "gas_giant": "Gigante gassoso",
          "ice_giant": "Gigante ghiacciato",
          "asteroid": "Asteroide",
          "city": "Pianeta città"
        },
        "unstable": "Instabile",
        "unstableHint": "Una stella a brillamento: la sua emissione esplode senza preavviso.",
        "systems": "Sistemi stellari",
        "name": "Nome",
        "kind": "Tipo",
        "retired": "Non presente in questa build",
        "starmap": "Mappa stellare",
        "starmapVisibility": "Mappa di gioco",
        "starmapHidden": "Nascosto sulla mappa",
        "starmapAlways": "Sempre visibile sulla mappa",
        "starmapWithParent": "Visibile quando %{parent} è selezionato",
        "starmapShown": "Visibile sulla mappa",
        "quantumTravel": "Viaggio quantico",
        "quantumTravelYes": "Sì",
        "quantumTravelNo": "No",
        "mapParent": "Disegnato sotto",
        "mapParentNote": "La mappa di gioco lo disegna sotto %{mapParent}, anche se si trova dentro %{parent}.",
        "missions": "Missioni",
        "allMissions": "Tutte le missioni che possono svolgersi qui",
        "terminals": "Terminali commerciali",
        "alwaysShown": "Sempre sulla mappa",
        "hiddenOnStarmap": "Nascosto sulla mappa",
        "facilities": "Atterraggio",
        "hangars": "Hangar",
        "hangarsNote": "Ogni hangar è istanziato per pilota: si contano le porte, non i posti.",
        "landingPads": "Piattaforme di atterraggio",
        "freeLandingPads": "Piattaforme di atterraggio libere",
        "freeLandingPadsNote": "Atterra senza che l'ATC assegni la piattaforma.",
        "vehiclePads": "Piattaforme per veicoli di terra",
        "dockingTubes": "Tubi di attracco",
        "kinds": {
          "system": "Sistema stellare",
          "star": "Stella",
          "planet": "Pianeta",
          "moon": "Luna",
          "city": "Città",
          "spaceport": "Spazioporto",
          "station": "Stazione",
          "outpost": "Avamposto",
          "clinic": "Clinica",
          "district": "Distretto",
          "asteroid": "Asteroide",
          "anomaly": "Anomalia",
          "jump_point": "Punto di salto",
          "point_of_interest": "Punto di interesse",
          "nav_point": "Punto di navigazione",
          "other": "Altro"
        }
      },
      "sortOptions": "Opzioni di ordinamento",
      "loading": "Caricamento…",
      "loadingNamed": "Caricamento di %{name}…",
      "true": "Si",
      "false": "No",
      "null": "-",
      "presets": {
        "title": "Scegli un'immagine",
        "filter": "Tipo",
        "all": "Tutte",
        "empty": "Nessuna immagine disponibile."
      },
      "maintainer": {
        "badge": "Manutentore",
        "tooltip": "Mantiene FleetYards.net"
      },
      "supporter": {
        "badge": "Sostenitore",
        "tooltip": "Sostiene FleetYards.net questo mese",
        "none": "Non è un sostenitore",
        "fleetTierUntil": "Livello flotta fino al %{date}",
        "fleetTierExpired": "Scaduto",
        "fleetTierOngoing": "Livello flotta finché l'abbonamento è attivo",
        "until": "Attivo fino al %{date}",
        "expiring": "Scade il %{date}",
        "ongoing": "Ricorrente, senza data di fine",
        "tierShort": "Livello %{tier}"
      },
      "destroyedFleets": {
        "discarded": "Scartata",
        "purged": "Eliminata definitivamente"
      },
      "and": "e",
      "hide": "Nascondi",
      "show": "Mostra",
      "only": "Solo",
      "description": "Descrizione",
      "unavailable": "non disponibile",
      "selected": "Selezionati",
      "actions": "Azioni",
      "status": "Stato",
      "enabled": "Abilitato",
      "disabled": "Disabilitato",
      "collapse": "Comprimi",
      "price": "Prezzo",
      "expand": "Espandi",
      "distance": "Distanza",
      "anonymous": "Anonimo",
      "refreshing": "Aggiornamento...",
      "toggleNavigation": "Attiva/disattiva navigazione",
      "openInNewWindow": "Apri a schermo intero",
      "or": "o",
      "groups": "Gruppi",
      "classifications": "Classificazioni",
      "features": {
        "stateOn": "Abilitato",
        "stateOff": "Disabilitato",
        "stateConditional": "Condizionale",
        "openFor": "Aperto da %{days} giorni",
        "historyEmpty": "Non è ancora stato registrato nulla per questa funzionalità.",
        "historyBy": "da %{actor}",
        "sources": {
          "admin": "Amministrazione",
          "self_service": "Self-service",
          "sync": "Deploy",
          "console": "Console",
          "backfill": "Recuperato"
        },
        "selfService": "Self-service",
        "actors": "Attori",
        "groups": "Gruppi",
        "noGroups": "Nessun gruppo abilitato per questa funzione.",
        "noActors": "Nessun attore individuale abilitato per questa funzione.",
        "user": "Utente",
        "fleet": "Flotta",
        "actorType": "Tipo di attore",
        "percentageOfActors": "degli attori",
        "percentageOfTime": "del tempo",
        "currentState": "Stato attuale",
        "toggle": "Attiva/Disattiva",
        "permanent": "Permanente",
        "tabs": {
          "all": "Tutte",
          "rollout": "Rollout",
          "permanent": "Permanenti"
        },
        "settingsIntro": "Attiva o disattiva le funzioni sperimentali per il tuo account. Queste funzioni potrebbero essere incomplete o cambiare senza preavviso.",
        "registryHint": "I flag sono dichiarati in config/feature_flags.yml e creati al deploy. Qui ne controlli le condizioni di attivazione.",
        "fleetSettingsIntro": "Attiva o disattiva le funzionalità per tutta la flotta. Ogni membro vede ciò che attivi qui.",
        "fleetFeature": "Funzionalità della flotta",
        "fleetFeatureInfo": "Attivandola qui vale solo per te. Gli amministratori della tua flotta possono attivarla per tutta la flotta.",
        "toggleForSelf": "Attiva solo per te",
        "fleetFeatureGrantedShort": "Attivato dalla flotta",
        "fleetFeatureGranted": "La tua flotta l'ha attivata per tutti i membri, quindi non può essere disattivata qui.",
        "groupFeatureGrantedShort": "Attivato dal gruppo",
        "groupFeatureGranted": "Un gruppo di cui fai parte ha questa funzionalità attiva, quindi non può essere disattivata qui.",
        "groupFeatureGrantedFleet": "Un gruppo di cui fa parte questa flotta ha questa funzionalità attiva, quindi non può essere disattivata qui.",
        "managedFeatureShort": "Gestito",
        "managedFeature": "Questa funzionalità è stata attivata per il tuo account e non può essere modificata qui.",
        "managedFeatureFleet": "Questa funzionalità è stata attivata per questa flotta e non può essere modificata qui.",
        "selfServiceUser": "Gli utenti possono attivarla",
        "selfServiceFleet": "Gli amministratori della flotta possono attivarla",
        "globalHint": "Attiva, la funzionalità è aperta a tutti. Disattiva, cancella ogni regola, compresi utenti, flotte e gruppi qui sotto.",
        "selfServiceHint": "Chi può attivare questa funzionalità da sé.",
        "lastChanged": "Ultima modifica: %{date}",
        "filterUsers": "Filtra per nome utente",
        "filterFleets": "Filtra per nome o SID",
        "noUsers": "Nessun utente ha questa funzionalità abilitata individualmente.",
        "noFleets": "Nessuna flotta ha questa funzionalità abilitata individualmente.",
        "noMatches": "Nessun risultato per il filtro.",
        "memberCount": "%{count} membri",
        "alreadyEnabled": "Questa flotta ha già la funzionalità."
      },
      "oauthApplication": {
        "name": "Nome applicazione",
        "clientId": "ID client",
        "clientSecret": "Segreto client",
        "redirectUri": "URI di reindirizzamento",
        "redirectUriHint": "Usare un URI per riga.",
        "confidential": "Riservato",
        "scopes": "Ambiti",
        "scopesHint": "Se non vengono selezionati ambiti, verranno utilizzati quelli predefiniti: %{scopes}",
        "logo": "Logo",
        "logoHint": "Mostrato nella schermata di consenso perché le persone riconoscano la tua applicazione. PNG, JPG, GIF o WebP."
      },
      "rsiRequestLogs": {
        "resolved": "Risolto",
        "unresolved": "Non risolto"
      },
      "imports": {
        "type": "Tipo",
        "status": "Stato",
        "version": "Versione",
        "startedAt": "Avviato",
        "finishedAt": "Terminato",
        "failedAt": "Fallito il",
        "info": "Info",
        "input": "Input",
        "output": "Output",
        "importData": "Dati di importazione",
        "file": "File importato",
        "requestedBy": "Richiesto da",
        "adminUser": "Utente admin",
        "user": "Utente",
        "includeSystem": "Includi sistema",
        "systemRequester": "sistema",
        "statuses": {
          "created": "In coda",
          "started": "In corso",
          "finished": "Terminato",
          "failed": "Fallito",
          "cancelled": "Annullato"
        },
        "targetGroupHint": "Scegli un gruppo dell'hangar e ogni nave importata verrà archiviata lì. Lascia vuoto per usare i gruppi indicati nel file.",
        "types": {
          "Imports::HangarImport": "Importazione hangar",
          "Imports::HangarSync": "Sincronizzazione hangar RSI"
        },
        "summary": {
          "imported": "Importate",
          "missing": "Non trovate",
          "found": "Abbinate"
        },
        "formatHint": "Sono accettati due formati di file:",
        "formats": {
          "fleetyards": "Un'esportazione dell'hangar di FleetYards: usa il pulsante Esporta per crearla.",
          "hangarXplor": "Un'esportazione di hangarXPLOR."
        },
        "details": {
          "imported": "Aggiunte",
          "found": "Abbinate",
          "movedToWanted": "Spostate nella lista dei desideri",
          "deleted": "Eliminate",
          "grouped": "Archiviate in un gruppo",
          "unchanged": "Lasciate invariate",
          "missing": "Navi non trovate",
          "missingComponents": "Componenti non trovati",
          "missingUpgrades": "Miglioramenti non trovati"
        },
        "noDetails": "Questa esecuzione non ha registrato dettagli."
      },
      "oauthApplications": {
        "settingsIntro": "Gestisci le tue applicazioni OAuth. Queste applicazioni possono accedere all'API di FleetYards per conto degli utenti.",
        "name": "Nome applicazione",
        "redirectUri": "URI di reindirizzamento",
        "confidential": "Riservato",
        "clientId": "ID client",
        "clientSecret": "Segreto client",
        "scopes": "Ambiti",
        "defaultScopes": "Ambiti predefiniti",
        "confidentialShort": "Riservato",
        "publicShort": "Pubblico",
        "logo": "Logo",
        "state": "Stato",
        "rejectionReason": "Motivo del rifiuto",
        "statePending": "In attesa di revisione",
        "stateApproved": "Approvata",
        "stateRejected": "Rifiutata",
        "reviewedBy": "Revisionata da",
        "owner": "Registrata da"
      },
      "fleetInviteToken": "Inviti Alla Flotta",
      "inviteToken": "Codice di invito",
      "scDataVersion": "Versione Della Patch",
      "title": "Titolo",
      "createdAt": "Creato il",
      "updatedAt": "Aggiornato il",
      "addToHangar": "Aggiungi all'hangar",
      "home": {
        "search": "Cerca Navi..."
      },
      "shop": {
        "sellPrice": "vende per",
        "buyPrice": "compra per"
      },
      "shopCommodity": {
        "item": "Articolo",
        "shop": "Negozio",
        "buyPrices": "Prezzo d'Acquisto",
        "rentalPrices": "Prezzo di Noleggio",
        "confirmed": "Confermato?",
        "prices": {
          "label": "Prezzi",
          "sellPrice": "vende per",
          "buyPrice": "compra per"
        }
      },
      "statsCard": {
        "more": "+%{count} altri nella pagina dei dettagli",
        "unavailable": "Impossibile caricare questi dettagli.",
        "loading": "Caricamento di %{name}…",
        "offeredBy": "Offerta da %{name}",
        "rsiHandle": "Handle RSI: %{handle}",
        "types": {
          "Component": "Componente",
          "Equipment": "Equipaggiamento",
          "Commodity": "Merce",
          "Model": "Nave",
          "Blueprint": "Progetto",
          "GameMission": "Missione",
          "Location": "Luogo",
          "FleetContract": "Contratto",
          "FleetEvent": "Evento",
          "User": "Utente",
          "FleetMember": "Membro"
        },
        "open": {
          "Component": "Apri componente",
          "Equipment": "Apri equipaggiamento",
          "Commodity": "Apri merce",
          "Model": "Apri nave",
          "Blueprint": "Apri progetto",
          "GameMission": "Apri missione",
          "Location": "Apri luogo",
          "FleetContract": "Apri contratto",
          "FleetEvent": "Apri evento",
          "User": "Apri hangar",
          "FleetMember": "Mostra nell'elenco membri"
        }
      },
      "stats": {
        "quickStats": {
          "newShips": "Nuove navi in %{year}",
          "totalShips": "Navi Totali",
          "totalMembers": "Membri Totali",
          "vehicles": "Navi in hangar",
          "wishlists": "Navi nella lista dei desideri",
          "shipOfTheMonth": "Nave del mese"
        },
        "modelsByClassification": "Navi per Classificazione",
        "modelsBySize": "Navi per Dimensioni",
        "vehiclesByModel": "Navi per Modello (Top %{limit})",
        "modelsPerMonth": "Navi al Mese",
        "modelsByManufacturer": "Navi per Produttore",
        "modelsByProductionStatus": "Navi per Stato di Produzione",
        "vehiclesPerMonth": "Navi in hangar al mese",
        "topVehiclesByModel": "Top 10 navi in hangar",
        "shipsOfTheMonth": "Nave del mese",
        "trendingShips": "Navi più viste (30 giorni)",
        "wishlistByModel": "Navi più desiderate",
        "wishToOwnRatio": "Desiderate ogni 100 possedute",
        "topPaints": "Vernici più popolari",
        "paintedVehicles": "Navi verniciate",
        "pledgePriceChanges": "Variazioni di prezzo pledge (12 mesi)",
        "ingamePriceChanges": "Variazioni di prezzo in gioco (30 giorni)",
        "mostWishlisted": "Navi più desiderate questo mese",
        "patchChanges": "Più modificate da questa patch",
        "crewDeficit": "Deficit equipaggio",
        "crewSurplus": "Surplus equipaggio",
        "membersByRole": "Membri per ruolo",
        "csv": {
          "metric": "Metrica",
          "value": "Valore",
          "count": "Conteggio"
        }
      },
      "roadmap": {
        "releases": "Rilasci",
        "released": "Rilasciato",
        "lastVersion": {
          "active": {
            "false": "Elemento rimosso dalla roadmap",
            "true": "Elemento riaggiunto alla roadmap"
          },
          "released": "L'Elemento rilasciato nel PU",
          "release": "L'Elemento è stato spostato dalla versione %{old} alla %{new}"
        },
        "stories": {
          "one": "%{count} Storia",
          "other": "%{count} Storie"
        },
        "tasks": {
          "one": "of %{count} Task",
          "other": "of %{count} Tasks"
        },
        "ships": {
          "one": "%{count} Nave",
          "other": "%{count} Navi"
        }
      },
      "unknown": "Sconosciuto",
      "none": "-",
      "notAvailable": "N/A",
      "not-available": "N/A",
      "name": "Nome",
      "homepage": "Homepage",
      "discord": "Server Discord",
      "youtube": "Canale YouTube",
      "twitch": "Canale Twitch",
      "guilded": "Server Guilded",
      "3dView": "3D",
      "3dMap": "Map",
      "viewInAr": "AR",
      "viewInArHint": "Posizionala nella tua stanza a grandezza reale",
      "filter": "Filtra",
      "taxExcluded": "IVA esclusa",
      "hangar": "Hangar",
      "public": "Pubblico",
      "hangarStats": "Statistiche",
      "wishlist": "Lista dei desideri",
      "fleetchart": "Grafico flotta",
      "fleetchartScale": "Scala delle navi",
      "fleetchartApp": {
        "screenHeight": "Altezza dello schermo",
        "viewpoint": "Punto di vista",
        "screenHeightOptions": {
          "1x": "1x",
          "1_5x": "1.5x",
          "2x": "2x",
          "3x": "3x",
          "4x": "4x"
        },
        "viewpointOptions": {
          "side": "Lato",
          "top": "Alto",
          "angled": "Angolato",
          "front": "Fronte"
        },
        "gridSize": "%{size} metro per cella della griglia",
        "mode": "Modalità",
        "modeOptions": {
          "classic": "Classico",
          "panzoom": "v2"
        }
      },
      "fleetStats": "Statistiche",
      "hangarMetrics": {
        "total": "Totale",
        "totalMoney": "Valore Monetario",
        "totalCredits": "Credits",
        "totalIngameValue": "Valore aUEC hangar",
        "totalCrew": "Equipaggio",
        "totalCargo": "Carico Totale",
        "largestShip": "Nave più grande",
        "smallestShip": "Nave più piccola",
        "averagePledgePrice": "Prezzo Pledge medio",
        "flightReady": "Pronto al volo",
        "uniqueModels": "Modelli unici",
        "manufacturerCount": "Produttori",
        "missingClassifications": "Ruoli mancanti",
        "wishlistTotalMoney": "Valore Pledge lista dei desideri",
        "wishlistTotalCredits": "Valore in gioco lista dei desideri"
      },
      "selectModel": "Seleziona una Nave",
      "findModel": "Scrivi per cercare una nave",
      "find": "Scrivi per cercare",
      "selectUser": "Seleziona un utente",
      "findUser": "Digita per trovare un utente",
      "selectAdminUser": "Seleziona un utente admin",
      "selectFleet": "Seleziona una flotta",
      "findFleet": "Digita per trovare una flotta",
      "compare": {
        "removeModel": "Rimuovi Nave",
        "addModel": {
          "nullablePrompt": "Aggiungi una Nave"
        },
        "enough": "Non pensi che 8 navi siano sufficienti? ;)",
        "shipCount": {
          "one": "%{count} nave",
          "other": "%{count} navi"
        },
        "containersOfSize": "Container da %{size} SCU",
        "armorHp": "HP corazza",
        "fuelAndQuantum": "Carburante e Quantum",
        "weaponPoolSize": "Riserva energetica armi",
        "crossSection": {
          "x": "Sezione trasversale X",
          "y": "Sezione trasversale Y",
          "z": "Sezione trasversale Z"
        },
        "useAsBaseline": "Usa come riferimento",
        "baseline": "Riferimento",
        "differencesOnly": "Solo le differenze",
        "compareToBaseline": "Confronta con il riferimento",
        "loadoutBySlot": "Configurazione per slot",
        "slots": {
          "guns": "Armi principali",
          "turrets": "Torrette",
          "missiles": "Missili",
          "shields": "Generatori di scudi",
          "powerPlants": "Generatori",
          "coolers": "Refrigeranti",
          "quantumDrives": "Motori Quantum",
          "thrusters": "Propulsori principali",
          "countermeasures": "Contromisure"
        },
        "legend": {
          "best": "migliore della riga",
          "worst": "peggiore",
          "share": "quota rispetto al migliore della riga",
          "better": "supera il riferimento",
          "worse": "resta indietro"
        },
        "selectShips": "Seleziona navi"
      },
      "au": "AU",
      "uec": "aUEC",
      "sell": "Vendi",
      "buy": "Compra",
      "yourFlagship": "La tua Ammiraglia",
      "flagship": "Ammiraglia",
      "fleet": {
        "headquarters": "Quartier generale",
        "index": "Flotta",
        "destroyInfo": "If you want to delete this Fleet and remove all its information from Fleetyards.net click the button below. Be aware that this is a permanent action and can't be reverted.",
        "classes": "Flotta",
        "fid": "ID Flotta",
        "name": "Nome",
        "logo": "Logo",
        "rsiSid": "SID",
        "rsiSettings": {
          "hint": "L’ID flotta è l’indirizzo della tua flotta su Fleetyards. Il SID collega la flotta alla sua organizzazione RSI, e verificarlo dimostra che l’organizzazione è tua."
        },
        "fidClaim": {
          "claimableTitle": "Rivendica l’ID flotta %{fid}",
          "claimable": "La tua flotta è verificata per l’organizzazione RSI %{fid}, ma un’altra flotta ha l’ID flotta %{fid}. Se lo rivendichi, quella flotta ha 14 giorni per dimostrare lei stessa l’organizzazione o avvisare i suoi membri. Poi viene rinominata e %{fid} diventa l’ID della tua flotta.",
          "pendingTitle": "Rivendicazione di %{fid} in corso",
          "pending": "%{holder} tiene %{fid} fino al %{date}. Poi l’ID passa alla tua flotta, a meno che quella flotta non dimostri prima di gestire l’organizzazione %{fid}.",
          "availableTitle": "L’ID flotta %{fid} è libero",
          "available": "La tua flotta è verificata per %{fid} e nessun’altra flotta usa quell’ID. Impostalo qui sopra come ID della tua flotta.",
          "incomingTitle": "%{claimant} rivendica l’ID della tua flotta",
          "incoming": "%{claimant} è verificata per l’organizzazione RSI **%{fid}**.\n\n**Il %{date}:**\n\n- La tua flotta passa al prossimo ID flotta libero, come **%{fid}-1**.\n- Da allora i link a %{fid} apriranno %{claimant}.\n\n**Per tenere l’ID**, verifica %{fid} prima. Altrimenti avvisa i tuoi membri del nuovo indirizzo.",
          "createTakenTitle": "%{fid} è già in uso",
          "createTaken": "Se %{fid} è la tua organizzazione RSI, inizia con %{suggestion} e il SID %{fid}. Appena la tua flotta è verificata per %{fid}, può rivendicare l’ID flotta dalla flotta che lo ha."
        },
        "rsiVerification": {
          "extension": {
            "title": "Verifica con l’estensione FleetYards Sync",
            "verify": "Verifica con l’estensione",
            "description": "L’estensione aggiunge il tuo codice alla storia della tua organizzazione su RSI, la pubblica, controlla la pagina e poi rimuove il codice.",
            "detecting": "Ricerca dell’estensione FleetYards Sync",
            "install": "Installa l’estensione FleetYards Sync per verificare la tua flotta con un clic.",
            "update": "Aggiorna l’estensione FleetYards Sync per verificare la tua flotta con un clic: la versione installata non lo supporta ancora.",
            "notSignedIn": "Accedi a RSI in questo browser con un account che può modificare %{sid}, oppure verifica a mano qui sotto.",
            "noRights": "L’account RSI con cui questo browser ha effettuato l’accesso non può modificare la pagina di %{sid}. Accedi con un account da ufficiale oppure verifica a mano qui sotto.",
            "pendingChanges": "%{sid} ha modifiche non pubblicate su RSI. Pubblica o cancella prima quella bozza, così l’estensione non pubblica la modifica di qualcun altro, oppure verifica a mano qui sotto.",
            "orgUnreadable": "L’estensione non è riuscita a leggere la pagina di %{sid} su RSI. Verifica a mano qui sotto.",
            "failed": "L’estensione non è riuscita ad aggiornare la pagina di %{sid}. Riprova oppure verifica a mano qui sotto.",
            "removeFailed": "L’estensione non è riuscita a rimuovere il codice dalla storia di %{sid}. Rimuovilo a mano.",
            "manual": "Oppure verifica a mano:"
          },
          "steps": {
            "copy": "Copia il tuo codice di verifica",
            "paste": "Incollalo in un punto qualsiasi della pagina RSI pubblica della tua organizzazione: introduzione, storia, manifesto o statuto. Puoi rimuoverlo una volta verificata la flotta.",
            "check": "Controlla la pagina"
          },
          "openOrgPage": "Apri %{sid} su RSI",
          "fidAtRiskTitle": "L’ID della tua flotta non è protetto",
          "saveFirst": "Salva il SID prima di verificarlo.",
          "title": "Verifica RSI",
          "token": "Codice di verifica",
          "verified": "Organizzazione RSI verificata",
          "unverified": "Non verificata su RSI",
          "verifiedSince": "Verificata dal %{date}",
          "nextCheck": "Puoi controllare di nuovo tra un minuto.",
          "fidAtRisk": "Un’altra flotta che verifica l’organizzazione RSI %{fid} può rivendicarlo, e l’indirizzo della tua flotta cambia.",
          "statuses": {
            "pending": "Controllo della pagina dell’organizzazione…",
            "token_missing": "Il codice non è ancora sulla pagina dell’organizzazione. RSI può impiegare qualche minuto a mostrare una modifica.",
            "symbol_mismatch": "La pagina restituita da RSI appartiene a un’altra organizzazione.",
            "not_found": "RSI non ha nessuna organizzazione con questo SID.",
            "failed": "Non è stato possibile controllare la pagina dell’organizzazione. Riprova tra un minuto."
          }
        },
        "description": "Descrizione",
        "public": "Fleetview Pubblica",
        "publicFleet": "Flotta pubblica",
        "publicStats": "Statistiche pubbliche",
        "publicFleetStats": "Statistiche flotta pubbliche",
        "discord": {
          "url": "Server Discord",
          "hint": "Collega un server Discord per rispecchiare gli eventi come eventi programmati nativi. I membri possono rispondere da Discord e l'iscrizione verrà sincronizzata su Fleetyards.",
          "guildId": "ID del server Discord",
          "channelId": "ID del canale vocale (facoltativo)",
          "webhookUrl": "URL del webhook per gli annunci (facoltativo)",
          "installBotHint": "Apre la pagina di installazione di Discord in una nuova scheda — scegli il server su cui vuoi rispecchiare gli eventi.",
          "announcementChannel": "Canale annunci",
          "announcementChannelHint": "Qui vengono pubblicati i nuovi eventi e i promemoria prima dell'inizio. Senza canale passano dal webhook. Gli eventi riservati a squadroni vengono pubblicati nei canali di quegli squadroni.",
          "officersChannel": "Canale ufficiali",
          "officersChannelHint": "Gli eventi visibili solo agli ufficiali vengono annunciati qui e in nessun altro punto di Discord. Senza canale non vengono annunciati su Discord. Anche le richieste di adesione vengono pubblicate qui, con pulsanti per accettarle o rifiutarle.",
          "digestWeekday": "Riepilogo settimanale",
          "digestWeekdayHint": "Una volta a settimana ogni canale riceve l'elenco degli eventi dei prossimi sette giorni che può vedere. Lascia vuoto per disattivarlo.",
          "digestTime": "Orario del riepilogo",
          "digestTimeHint": "Nel tuo fuso orario (%{timezone}).",
          "channelMissing": "Questo canale non esiste più su Discord o non accetta più pubblicazioni. Non viene pubblicato nulla finché non ne scegli un altro.",
          "missingChannel": "Canale non disponibile",
          "joinRole": "Ruolo di ingresso",
          "joinRoleHint": "I giocatori con questo ruolo nel server entrano nella flotta senza richiesta, con il grado predefinito. Togliendo il ruolo, i membri entrati grazie a esso lasciano la flotta. Lascia vuoto per approvare ogni richiesta a mano.",
          "roleMissing": "Questo ruolo non esiste più su Discord. Nessuno entra tramite esso finché non ne viene scelto un altro.",
          "missingRole": "Ruolo non disponibile",
          "saveGuildFirst": "Salva prima il nuovo server, poi scegline i canali e i ruoli.",
          "roleMapping": "Ruoli Discord",
          "roleMappingHint": "Fleetyards assegna questi ruoli ai membri nel server e li toglie quando cambiano grado o lasciano la flotta. Aggiunge o toglie solo i ruoli scelti qui.",
          "memberRole": "Ruolo membro",
          "memberRoleHint": "Ogni membro della flotta riceve questo ruolo, qualunque sia il suo grado.",
          "rolesCodes": {
            "missing_manage_roles": "Il bot non può gestire i ruoli in questo server. Usa il link di installazione per autorizzarlo di nuovo.",
            "unknown_role": "Un ruolo scelto qui non esiste più su Discord: %{names}.",
            "role_above_bot": "Il bot non può assegnare %{names}: Discord gli permette di dare solo ruoli sotto il proprio. Sposta il ruolo del bot sopra di essi nelle impostazioni del server."
          },
          "postingCodes": {
            "missing_send_messages": "Il bot non può inviare messaggi in questo server. Usa il link di installazione per autorizzarlo di nuovo.",
            "channel_locked": "Il bot non può pubblicare nel canale scelto per %{names}. Consentilo nei permessi di quel canale.",
            "unknown_channel": "Il canale scelto per %{names} non esiste più su Discord o non accetta più pubblicazioni.",
            "channel_shared": "%{names} condivide un canale con lettori a cui i suoi eventi sono nascosti. Non viene pubblicato nulla finché ognuno non ha un canale proprio."
          },
          "joinRoleCodes": {
            "members_intent_missing": "Il bot di Fleetyards non può ancora elencare i membri di questo server, quindi il ruolo di adesione vale solo quando un giocatore usa un link di invito. Contatta un amministratore.",
            "live_updates_off": "Le modifiche ai ruoli arrivano a Fleetyards una volta al giorno: il bot non le ascolta mentre avvengono. Contatta un amministratore.",
            "bot_offline": "Il bot di Fleetyards non è connesso a Discord in questo momento, quindi le modifiche ai ruoli attendono la sincronizzazione giornaliera. Contatta un amministratore."
          },
          "statusOk": "Connesso a %{name}",
          "statusCodes": {
            "missing_token": "Il bot Fleetyards non è configurato lato server. Contatta un amministratore.",
            "missing_guild": "Inserisci prima un ID del server Discord.",
            "invalid_token": "Il token del bot non è valido. Contatta un amministratore.",
            "bot_not_in_guild": "Il bot non è presente in questo server. Usa il link di installazione per aggiungerlo.",
            "guild_not_found": "Discord non riconosce questo ID del server. Ricontrolla il valore.",
            "discord_error": "Discord ha restituito un errore imprevisto.",
            "request_failed": "Non è stato possibile raggiungere Fleetyards. Riprova."
          }
        },
        "guilded": "Server Guilded",
        "homepage": "Homepage",
        "twitch": "Canale Twitch",
        "youtube": "Canale Youtube",
        "backgroundImage": "Immagine di sfondo",
        "ts": "Server Teamspeak",
        "awaitingConfirmation": "In attesa di conferma dalla Flotta",
        "members": {
          "verifiedOrgMember": "Membro verificato di %{sid}",
          "verifiedOrgMemberChecked": "Membro verificato di %{sid}, controllato %{checked}",
          "primary": "Flotta Primaria?",
          "shipsFilter": {
            "label": "Quali navi dovrebbero essere aggiunte alla flotta?",
            "nullablePrompt": "Nessuna opzione selezionata",
            "field": "Seleziona Navi",
            "values": {
              "all": "Tutte le navi",
              "hangar_group": "Tutte le navi in un dato gruppo Hangar",
              "hide": "Nessuna Nave"
            }
          },
          "hangarGroupId": {
            "field": "Gruppo Hangar",
            "label": "Specifica un Gruppo Hangar",
            "nullablePrompt": "Nessun Gruppo selezionato"
          },
          "blueprintsFilter": {
            "label": "Quali progetti condividere con la flotta?",
            "nullablePrompt": "Nessuna opzione selezionata",
            "field": "Selezione progetti",
            "values": {
              "all": "Tutti i progetti che possiedo",
              "hide": "Nessun progetto"
            }
          },
          "total": "Totale: %{count}",
          "rsiTotal": "Su RSI: %{count}",
          "joined": "Iscritto il",
          "invited": "Invitato",
          "invitedAt": "Invitato / Richiesto il",
          "requested": "Iscrizione Richiesta",
          "declined": "Rifiutata",
          "pending": "Inviti e richieste in attesa",
          "accepted": "Membri",
          "role": "Ruolo",
          "contact": "Contact",
          "spectrumDm": "Message on Spectrum",
          "discordContact": "Discord",
          "views": {
            "members": "Membri",
            "invites": "Inviti"
          },
          "health": {
            "overview": "Controlli",
            "summary": {
              "attention": {
                "one": "%{count} controllo su %{total} richiede attenzione",
                "other": "%{count} controlli su %{total} richiedono attenzione"
              },
              "clear": "Tutti i %{total} controlli sono a posto"
            },
            "groups": {
              "leadership": "Comando",
              "rsi": "Organizzazione RSI",
              "activity": "Attività",
              "requests": "Richieste e inviti",
              "integrations": "Integrazioni"
            },
            "days": {
              "one": "%{count} giorno",
              "other": "%{count} giorni"
            },
            "checks": {
              "admins": {
                "title": "Admin",
                "overview": "Admin",
                "clear": "%{admins} membri sono admin."
              },
              "unverified": {
                "title": "Non verificati con %{sid}",
                "overview": "Non verificati",
                "description": "Un membro è verificato quando il suo elenco di organizzazioni RSI include %{sid}. Ogni riga spiega perché non è stato possibile confermarlo.",
                "clear": "Tutti i membri sono verificati con %{sid}."
              },
              "noHandle": {
                "title": "Nessun handle RSI",
                "overview": "Nessun handle RSI",
                "clear": "Tutti i membri hanno indicato un handle RSI."
              },
              "inactive": {
                "title": "Membri inattivi",
                "overview": "Inattivi da %{count}+ giorni",
                "clear": "Tutti sono stati attivi negli ultimi %{count} giorni."
              },
              "joinRequests": {
                "title": "Richieste di adesione in attesa da oltre una settimana",
                "overview": "Richieste vecchie",
                "clear": "Nessuna richiesta attende da più di una settimana."
              },
              "invitations": {
                "title": "Inviti senza risposta",
                "overview": "Inviti senza risposta",
                "clear": "Nessun invito è aperto da più di due settimane."
              },
              "inviteUrls": {
                "title": "Link d'invito da sistemare",
                "overview": "Link d'invito",
                "clear": "Tutti i link d'invito sono in uso."
              },
              "discord": {
                "title": "Discord non collegato",
                "overview": "Discord",
                "clear": "Tutti i membri hanno collegato Discord."
              },
              "emptySquadrons": {
                "title": "Squadriglie senza membri",
                "overview": "Squadriglie vuote",
                "clear": "Ogni squadriglia ha dei membri."
              },
              "noSquadron": {
                "title": "Membri senza squadriglia",
                "overview": "Senza squadriglia",
                "clear": "Tutti i membri sono in una squadriglia."
              },
              "hiddenShips": {
                "title": "Navi escluse dalla flotta",
                "overview": "Hangar nascosti",
                "clear": "Tutti i membri condividono le loro navi con la flotta."
              }
            },
            "facts": {
              "joined": "Entrato il %{date}",
              "lastActive": "Ultima attività %{distance}",
              "neverActive": "Mai attivo",
              "checked": "Controllato %{distance}",
              "requested": "Richiesto %{distance}",
              "invited": "Invitato %{distance}",
              "invitedBy": "Invitato da %{name}",
              "noDiscord": "Nessun account Discord collegato",
              "noSquadron": "Nessuna squadriglia",
              "noHandle": "Nessun handle indicato",
              "linkExpired": "Scaduto %{distance}",
              "linkUsedUp": "Nessun utilizzo rimasto",
              "createdBy": "Creato da %{name}",
              "used": {
                "one": "Usato una volta",
                "other": "Usato %{count} volte"
              },
              "team": "Squadra",
              "created": "Creata il %{date}",
              "linkUnused": "Mai usato, creato %{distance}"
            },
            "gaps": {
              "no_handle": "Nessun handle RSI nel profilo",
              "handle_unverified": "Handle RSI non verificato",
              "orgs_not_checked": "Elenco organizzazioni non ancora letto",
              "org_not_listed": "%{sid} non è nel suo elenco di organizzazioni"
            },
            "orgStats": {
              "rsi": "%{sid} su RSI",
              "roster": "Su FleetYards",
              "gap": "Mai entrati qui"
            },
            "fleetNotVerified": "%{sid} non è ancora verificata, quindi altrove nessun membro risulta verificato.",
            "singleAdmin": "Se %{name} se ne va o perde l'accesso, nessuno potrà gestire %{fleet} su FleetYards.",
            "hiddenShips": {
              "one": "%{count} membro tiene il suo hangar fuori dall'elenco navi della flotta.",
              "other": "%{count} membri tengono il loro hangar fuori dall'elenco navi della flotta."
            },
            "deleteLinkFailed": "Non è stato possibile eliminare il link d'invito.",
            "noAdmin": "Nessuno è admin, quindi nessuno può gestire %{fleet} su FleetYards.",
            "adminCandidates": "Promuovi ad admin",
            "addedToSquadron": {
              "success": "Aggiunto alla squadriglia.",
              "failure": "Impossibile aggiungere alla squadriglia."
            },
            "reminded": {
              "success": "Promemoria inviato.",
              "failure": "Non è stato possibile inviare il promemoria."
            },
            "remindedAt": "Promemoria inviato %{distance}. Potrai inviarne un altro una settimana dopo."
          },
          "card": {
            "verified": "Verificato",
            "unverified": "Non verificato",
            "squadrons": "Squadriglie"
          }
        },
        "squadrons": {
          "index": "Squadroni",
          "name": "Nome",
          "shortDescription": "Descrizione breve",
          "shortDescriptionHint": "Una o due righe, sulla scheda",
          "description": "Descrizione",
          "descriptionHint": "Il testo completo sulla pagina dello squadrone",
          "noDescription": "Non è stata ancora aggiunta una descrizione.",
          "icon": "Icona",
          "iconHint": "Immagine quadrata, mostrata in un cerchio",
          "team": "Squadra",
          "teamHint": "Una squadra è aperta a tutti, altrimenti un membro appartiene a un solo squadrone",
          "restrictedToHint": "Solo questi squadroni possono vederlo",
          "discordChannel": "Canale Discord",
          "discordChannelHint": "Gli eventi riservati a questo squadrone vengono annunciati qui e in nessun altro punto di Discord. Senza canale non vengono annunciati su Discord.",
          "notAnnounced": "Nessun annuncio su Discord per %{names}: non è configurato alcun canale Discord.",
          "blockedBy": "Già nello squadrone %{squadron}",
          "color": "Colore",
          "colorSuggestions": "Dall'icona:",
          "memberCount": "%{count} membri",
          "members": "Membri",
          "joinedAt": "Data di ingresso nello squadrone",
          "searchMembers": "Cerca membri",
          "availableMembers": "membri disponibili",
          "selectedMembers": "%{count} selezionati",
          "rank": "Grado",
          "ranksHint": "I nomi usati da ogni squadrone di questa flotta. Un grado rinominato mantiene il suo posto e i suoi permessi.",
          "rankName": "Nome",
          "defaultRank": "Predefinito",
          "defaultRankToggle": "I nuovi membri iniziano con questo grado",
          "rankRights": {
            "singleHolder": "Uno per squadrone",
            "managesMembers": "Aggiunge e rimuove i membri di grado inferiore",
            "managesRanks": "Stabilisce i gradi inferiori al proprio"
          },
          "views": {
            "members": "Membri",
            "requests": "Richieste"
          },
          "requestedAt": "Richiesto il",
          "requests": "Richieste"
        },
        "roles": {
          "permanent": "Permanente",
          "default": "Predefinito",
          "defaultToggle": "I nuovi membri ricevono questo ruolo",
          "privilegeGroups": {
            "fleet": "Flotta",
            "memberships": "Membri",
            "squadrons": "Squadroni",
            "invites": "Inviti",
            "vehicles": "Veicoli",
            "blueprints": "Progetti",
            "roles": "Ruoli",
            "inventories": "Inventari",
            "missions": "Missioni",
            "events": "Eventi",
            "allies": "Alleati",
            "contracts": "Contratti",
            "payouts": "Pagamenti",
            "notifications": "Notifiche",
            "announcements": "Annunci"
          },
          "privileges": {
            "fleet:update": "Aggiorna flotta",
            "fleet:update:images": "Aggiorna immagini",
            "fleet:update:description": "Aggiorna descrizione",
            "fleet:delete": "Elimina flotta",
            "fleet:manage": "Gestisci flotta",
            "fleet:memberships:read": "Visualizza membri",
            "fleet:memberships:create": "Invita membri",
            "fleet:memberships:update": "Aggiorna membri",
            "fleet:memberships:delete": "Rimuovi membri",
            "fleet:memberships:manage": "Gestisci membri",
            "fleet:squadrons:read": "Vedere gli squadroni",
            "fleet:squadrons:create": "Creare squadroni",
            "fleet:squadrons:update": "Modificare squadroni",
            "fleet:squadrons:delete": "Eliminare squadroni",
            "fleet:squadrons:members:manage": "Gestire i membri dello squadrone",
            "fleet:squadrons:manage": "Gestire gli squadroni",
            "fleet:invites:read": "Visualizza inviti",
            "fleet:invites:create": "Crea inviti",
            "fleet:invites:update": "Aggiorna inviti",
            "fleet:invites:delete": "Elimina inviti",
            "fleet:invites:manage": "Gestisci inviti",
            "fleet:vehicles:read": "Visualizza veicoli",
            "fleet:vehicles:create": "Aggiungi veicoli",
            "fleet:vehicles:update": "Aggiorna veicoli",
            "fleet:vehicles:delete": "Rimuovi veicoli",
            "fleet:vehicles:manage": "Gestisci veicoli",
            "fleet:blueprints:read": "Vedi i progetti",
            "fleet:roles:read": "Visualizza ruoli",
            "fleet:roles:create": "Crea ruoli",
            "fleet:roles:update": "Aggiorna ruoli",
            "fleet:roles:delete": "Elimina ruoli",
            "fleet:roles:manage": "Gestisci ruoli",
            "fleet:inventories:read": "Visualizza inventari",
            "fleet:inventories:create": "Crea inventari",
            "fleet:inventories:update": "Aggiorna inventari",
            "fleet:inventories:delete": "Elimina inventari",
            "fleet:inventories:manage": "Gestisci inventari",
            "fleet:missions:read": "Visualizza missioni",
            "fleet:missions:create": "Crea missioni",
            "fleet:missions:update": "Aggiorna missioni",
            "fleet:missions:delete": "Elimina missioni",
            "fleet:missions:manage": "Gestisci missioni",
            "fleet:events:read": "Visualizza eventi",
            "fleet:events:create": "Crea eventi",
            "fleet:events:update": "Aggiorna eventi",
            "fleet:events:delete": "Elimina eventi",
            "fleet:events:manage": "Gestisci eventi",
            "fleet:allies:read": "Visualizza alleati",
            "fleet:allies:create": "Aggiungi alleati",
            "fleet:allies:delete": "Rimuovi alleati",
            "fleet:allies:manage": "Gestisci alleati",
            "fleet:contracts:read": "Visualizza contratti",
            "fleet:contracts:create": "Crea contratti",
            "fleet:contracts:update": "Aggiorna contratti",
            "fleet:contracts:delete": "Elimina contratti",
            "fleet:contracts:manage": "Gestisci contratti",
            "fleet:payouts:read": "Visualizza pagamenti",
            "fleet:payouts:create": "Registra pagamenti",
            "fleet:payouts:update": "Aggiorna pagamenti",
            "fleet:payouts:delete": "Elimina pagamenti",
            "fleet:payouts:manage": "Gestisci pagamenti",
            "fleet:notifications:manage": "Gestisci impostazioni notifiche",
            "fleet:announcements:manage": "Gestisci annunci"
          },
          "name": "Nome",
          "rank": "Rango"
        },
        "inviteUrls": {
          "noExpiration": "Nessuna scadenza",
          "used": "Usato %{count} volte",
          "usedOfLimit": "%{count} di %{limit} utilizzati",
          "expiresIn": "Scade tra %{time}",
          "expired": "Scaduto",
          "expiresAfterOptions": {
            "infinite": "Mai",
            "30_minutes": "30 minuti",
            "1_hour": "1 ora",
            "6_hours": "6 ore",
            "12_hours": "12 ore",
            "1_day": "1 giorno",
            "7_days": "7 giorni"
          },
          "limitOptions": {
            "1": "1 uso",
            "5": "5 utilizzi",
            "10": "10 utilizzi",
            "25": "25 utilizzi",
            "50": "50 utilizzi",
            "100": "100 utilizzi",
            "infinite": "Nessun limite"
          }
        },
        "calendarSubscription": {
          "intro": "Genera un link privato che i membri possono usare per iscriversi agli eventi di questa flotta dalla loro app calendario (Apple Calendar, Google Calendar, Outlook).",
          "howTo": "Condividi il link qui sopra con i tuoi membri. Lo incollano nella loro app calendario (\"Iscriviti a un calendario\" o \"Aggiungi tramite URL\"). Il link è privato — chiunque lo possieda può vedere gli eventi di questa flotta."
        },
        "notifications": {
          "inAppHint": "Scegli quali cambiamenti di stato degli eventi appaiono come notifiche nell'app per i membri della flotta.",
          "events": {
            "fleet_event": {
              "published": "Evento pubblicato",
              "locked": "Iscrizioni bloccate",
              "unlocked": "Iscrizioni riaperte",
              "starting_soon": "Evento in partenza",
              "started": "Evento avviato",
              "completed": "Evento completato",
              "cancelled": "Evento annullato",
              "archived": "Evento archiviato",
              "destroyed": "Evento eliminato"
            },
            "fleet_event_signup": {
              "created": "Iscrizione aggiunta",
              "withdrawn": "Iscrizione ritirata"
            }
          }
        },
        "inventories": {
          "name": "Nome",
          "description": "Descrizione",
          "location": "Posizione",
          "visibility": "Visibilità",
          "manager": "Responsabile",
          "itemsCount": "Voci",
          "visibilities": {
            "members_only": "Solo membri",
            "officers_only": "Solo ufficiali",
            "squadron_only": "Solo squadrone"
          }
        },
        "allies": "Navi visibili agli alleati",
        "alliesStats": "Statistiche visibili agli alleati",
        "alliesMembers": "Elenco membri visibile agli alleati",
        "squadronsEnabled": "Usa gli squadroni",
        "listed": "Mostra nella directory delle flotte",
        "listedInfo": "Una flotta verificata e pubblica con almeno due membri compare nella directory delle flotte. Una flotta privata non compare mai.",
        "alignment": "Allineamento",
        "alignments": {
          "lawful": "Legale",
          "neutral": "Neutrale",
          "outlaw": "Fuorilegge"
        },
        "activities": {
          "bounty_hunting": "Caccia alle taglie",
          "engineering": "Ingegneria",
          "exploration": "Esplorazione",
          "freelancing": "Freelance",
          "infiltration": "Infiltrazione",
          "medical": "Medicina",
          "piracy": "Pirateria",
          "resources": "Risorse",
          "scouting": "Ricognizione",
          "security": "Sicurezza",
          "smuggling": "Contrabbando",
          "social": "Sociale",
          "trading": "Commercio",
          "transport": "Trasporto"
        },
        "commitments": {
          "casual": "Occasionale",
          "regular": "Regolare",
          "hardcore": "Hardcore"
        },
        "rsiProfile": {
          "info": "Sincronizzato una volta al giorno dalla pagina RSI della tua organizzazione. Modificalo su RSI.",
          "primaryActivity": "Attività principale",
          "secondaryActivity": "Attività secondaria",
          "language": "Lingua",
          "commitment": "Impegno",
          "recruiting": "Recluta",
          "roleplay": "Gioco di ruolo"
        },
        "contractCovers": {
          "transport": "Copertina trasporto",
          "procurement": "Copertina approvvigionamento",
          "crafting": "Copertina fabbricazione"
        }
      },
      "hangarGroup": {
        "name": "Nome",
        "color": "Colore",
        "sort": "Ordina per",
        "public": "Mostrare nell'Hangar pubblico?"
      },
      "source": "Fonte",
      "loadout": {
        "namePlaceholder": "Nome configurazione...",
        "urlPlaceholder": "Incolla l'URL della configurazione di erkul.games o spviewer.eu...",
        "empty": "Ancora nessuna configurazione. Creane una per iniziare.",
        "active": "Attiva",
        "activate": "Rendi attiva"
      },
      "model": {
        "hidden": "Nascosto?",
        "active": "Attivo?",
        "inGame": "Nel gioco?",
        "adiMap": "Mappa ADI?",
        "ground": "Veicolo terrestre?",
        "productionNote": "Nota di produzione",
        "rsiId": "RSI ID",
        "length": "Lunghezza",
        "beam": "Larghezza",
        "height": "Altezza",
        "scKey": "SC Key",
        "price": "Prezzo",
        "pledgePrice": "Prezzo Pledge",
        "erkulIdentifier": "Erkul Identifier",
        "mass": "Massa",
        "crew": "Equipaggio",
        "storeUrl": "Store URL",
        "salesPageUrl": "Sales Page URL",
        "scmSpeed": "SCM Speed",
        "scmSpeedBoosted": "SCM Speed Boosted",
        "maxSpeed": "Velocità max.",
        "reverseSpeedBoosted": "Reverse Speed Boosted",
        "cargo": "Carico",
        "cargoHolds": "Stive di carico",
        "hydrogenFuelTankSize": "Dimensione serbatoio idrogeno",
        "hydrogenFuelTanks": "Serbatoi carburante idrogeno",
        "quantumFuelTankSize": "Dimensione serbatoio Quantum",
        "quantumFuelTanks": "Serbatoi carburante Quantum",
        "externalFuelTanks": "Serbatoi di carburante esterni",
        "externalFuelTanksTotal": "Capacità totale",
        "externalFuelTanksCount": "Pod",
        "refuelBoom": "Braccio di rifornimento",
        "refuelBoomArm": "Braccio",
        "refuelBoomNozzle": "Ugello",
        "yaw": "Yaw",
        "pitch": "Pitch",
        "roll": "Roll",
        "yawBoosted": "Imbardata potenziata",
        "pitchBoosted": "Beccheggio potenziato",
        "rollBoosted": "Rollio potenziato",
        "variants": "Varianti",
        "manufacturer": "Produttore",
        "loaners": "Navi in comodato",
        "paints": "Verniciature",
        "modules": "Moduli",
        "modulePackages": "Pacchetti Modulo",
        "upgrades": "Kit Di Potenziamento",
        "brochure": "Opuscolo",
        "holo": "Holo",
        "angledView": "Vista angolata",
        "angledViewColored": "Vista angolata a colori",
        "sideView": "Vista laterale",
        "sideViewColored": "Vista laterale a colori",
        "frontView": "Vista frontale",
        "frontViewColored": "Vista frontale a colori",
        "topView": "Vista dall'alto",
        "topViewColored": "Vista dall'alto a colori",
        "onSale": "In Vendita",
        "playerOwnable": "Acquistabile dai giocatori?",
        "ingameOnly": "Solo in gioco",
        "canLandOnPlanets": "Può atterrare sui pianeti",
        "cannotLandOnPlanets": "Non può atterrare sui pianeti",
        "salesPage": "Pagina Di Vendita",
        "addons": "Moduli E Kit Di Potenziamento",
        "storeImage": "Immagine negozio",
        "wiki": "Star Citizen Wiki",
        "crewPositions": "Postazioni dell'equipaggio",
        "needsCuration": "Richiede revisione",
        "curatedPosition": "Posizione curata manualmente",
        "baseModel": "Modello base",
        "fleetchartOffsetLength": "Offset lunghezza grafico flotta",
        "fleetchartOffsetBeam": "Offset larghezza grafico flotta",
        "extendedLength": "Lunghezza estesa",
        "extendedBeam": "Larghezza estesa",
        "extendedHeight": "Altezza estesa",
        "extendedFleetchartOffsetLength": "Offset lunghezza grafico flotta esteso",
        "extendedFleetchartOffsetBeam": "Offset larghezza grafico flotta esteso",
        "defaultHolo": "Holo predefinito",
        "extendedHolo": "Holo esteso",
        "extendedTopView": "Vista dall'alto estesa",
        "extendedTopViewColored": "Vista dall'alto estesa a colori",
        "extendedSideView": "Vista laterale estesa",
        "extendedSideViewColored": "Vista laterale estesa a colori",
        "extendedFrontView": "Vista frontale estesa",
        "extendedFrontViewColored": "Vista frontale estesa a colori",
        "extendedAngledView": "Vista angolata estesa",
        "extendedAngledViewColored": "Vista angolata estesa a colori",
        "landedHolo": "Holo atterrato",
        "landedTopView": "Vista dall'alto atterrata",
        "landedSideView": "Vista laterale atterrata",
        "landedFrontView": "Vista frontale atterrata",
        "landedAngledView": "Vista angolata atterrata",
        "landedTopViewColored": "Vista dall'alto atterrata a colori",
        "landedSideViewColored": "Vista laterale atterrata a colori",
        "landedFrontViewColored": "Vista frontale atterrata a colori",
        "landedAngledViewColored": "Vista angolata atterrata a colori",
        "state": {
          "flight": "In volo",
          "extended": "Estesa",
          "landed": "Atterrata"
        },
        "productionStatus": {
          "in-production": "In Produzione",
          "in-concept": "In fase di progettazione",
          "ready": "Pronto per l'hangar",
          "flight-ready": "Pronto al volo",
          "announced": "Annunciato"
        },
        "carriedBy": "Può essere trasportata da",
        "landedLength": "Lunghezza a terra",
        "landedBeam": "Larghezza a terra",
        "landedHeight": "Altezza a terra",
        "landedFleetchartOffsetLength": "Scostamento lunghezza atterrato",
        "landedFleetchartOffsetBeam": "Scostamento larghezza atterrato",
        "owners": {
          "title": "Nella tua cerchia",
          "yourShips": "Le tue navi",
          "friends": "Amici",
          "fleets": "Le tue flotte",
          "more": "+%{count} altri",
          "empty": "Nessuno che conosci ne ha ancora uno.",
          "fleetShips": {
            "one": "%{count} nave",
            "other": "%{count} navi"
          }
        }
      },
      "models": {
        "extraColumns": "Colonne",
        "table": {
          "columns": {
            "storeImage": "Immagine",
            "storeImageWide": "Immagine larga",
            "rsiStoreImage": "Immagine RSI",
            "rsiStoreImageWide": "Immagine RSI larga",
            "angledView": "Immagine 3D",
            "angledViewWide": "Immagine 3D larga",
            "rsiId": "RSI ID",
            "hidden": "Nascosto",
            "active": "Attivo",
            "createdAt": "Creato il",
            "updatedAt": "Aggiornato il",
            "manufacturerName": "Produttore",
            "length": "Lunghezza",
            "beam": "Larghezza",
            "height": "Altezza",
            "mass": "Massa",
            "cargo": "Carico",
            "quantumFuelTankSize": "Carburante Quantum",
            "hydrogenFuelTankSize": "Carburante idrogeno",
            "crew": "Equipaggio",
            "scmSpeed": "SCM Speed",
            "maxSpeed": "Velocità max.",
            "groundMaxSpeed": "Velocità a terra",
            "focus": "Specializzazione",
            "productionStatus": "Stato di produzione",
            "price": "Prezzo",
            "pledgePrice": "Prezzo Pledge"
          }
        }
      },
      "metrics": {
        "info": "Info",
        "levels": "Livelli",
        "views": "Visualizzazioni",
        "base": "Base",
        "crew": "Equipaggio",
        "speed": "Velocità",
        "cargo": "Carico",
        "combat": "Combattimento",
        "hardpoints": "Punti di montaggio"
      },
      "flight": {
        "boostCapacitor": "Condensatore boost",
        "boostCapacity": "Capacità",
        "boostRegen": "Rigenerazione",
        "boostRegenDelay": "Ritardo rigenerazione",
        "boostRamp": "Avvio / rilascio",
        "title": "Volo",
        "scm": "crociera da combattimento",
        "nav": "crociera",
        "boost": "Boost",
        "boostSub": "postbruciatore",
        "reverse": "Retromarcia",
        "maneuverability": "Manovrabilità",
        "fuel": "Carburante",
        "fuelHydrogen": "Idrogeno",
        "fuelQuantum": "Quantum",
        "hint": "La manovrabilità potenziata dipende dai pips del motore; tutto a zero quando il motore non è alimentato."
      },
      "base": {
        "price": "Prezzo",
        "priceInGame": "In-game",
        "pricePledge": "Pledge",
        "availability": "Disponibilità"
      },
      "availability": {
        "title": "Disponibilità",
        "buy": "Acquisto",
        "rent": "Noleggio",
        "sell": "Vendita",
        "cheapest": {
          "buy": "Acquisto più economico",
          "rent": "Noleggio più economico"
        },
        "bestSale": "Miglior prezzo di vendita",
        "allLocations": "Tutte le posizioni",
        "locations": {
          "one": "%{count} posizione",
          "other": "%{count} posizioni"
        },
        "empty": "Nessuna posizione di acquisto o noleggio conosciuta.",
        "timeRange": {
          "1-day": "1 giorno",
          "3-days": "3 giorni",
          "7-days": "7 giorni",
          "30-days": "30 giorni"
        }
      },
      "cargo": {
        "title": "Carico",
        "holdsSub": "su %{count} stive",
        "maxContainerSub": "il container più grande che ci sta",
        "containers": "Capacità in container",
        "hint": "Numero massimo di container di ciascuna dimensione che entrano nelle griglie di carico; la barra mostra quanta parte della capacità totale occupano."
      },
      "fuelTanks": {
        "capacitySub": "su %{count} pod",
        "podsSub": "attacchi esterni",
        "components": "Tipi di pod",
        "perPod": "per pod",
        "hint": "Carburante trasportato in pod montati su punti di montaggio esterni; la barra mostra la quota di ciascun tipo sulla capacità totale."
      },
      "refuelBoom": {
        "fuelFlowSub": "trasferimento idrogeno",
        "quantumFlowSub": "trasferimento quantum",
        "captureRadiusSub": "tolleranza di aggancio",
        "equipment": "Equipaggiamento",
        "hint": "Velocità di trasferimento del braccio di rifornimento e tolleranza di aggancio del suo ugello."
      },
      "combat": {
        "title": "Combattimento",
        "openPenetrationCheck": "Verifica penetrazione",
        "dps": "DPS di raffica",
        "dpsSub": "%{count} armi",
        "sustained": "DPS sostenuto",
        "sustainedSub": "con regen e calore",
        "alpha": "Alpha",
        "alphaSub": "per salva",
        "weapons": "Armi",
        "missileDamage": "Danno dei missili",
        "armedMissiles": "Missili armati",
        "armedMissilesSub": "%{cooldown} s tra i lanci",
        "composition": "Composizione del danno",
        "damagePhysical": "Fisico",
        "damageEnergy": "Energia",
        "damageDistortion": "Distorsione",
        "damageThermal": "Termico",
        "controlComposition": "DPS per controllo",
        "controlGroups": {
          "pilot": "Pilota",
          "manned": "Torretta con equipaggio",
          "remote": "Torretta remota",
          "pds": "Difesa ravvicinata"
        },
        "hint": "DPS della configurazione predefinita. Il valore sostenuto tiene conto della rigenerazione della riserva energetica di ogni arma e del ciclo di surriscaldamento. Missili esclusi."
      },
      "power": {
        "title": "Distribuzione dell'energia",
        "scm": "SCM",
        "nav": "NAV",
        "reset": "Reimposta",
        "auto": "Auto",
        "aimAssist": "Assistenza alla mira",
        "cooling": "Raffreddamento",
        "ir": "IR",
        "em": "EM",
        "cs": "CS",
        "csAxisHint": "Clicca per cambiare asse (x / y / z)",
        "segmentsUsed": "%{used} / %{total} segmenti",
        "hint": "Sposta l'energia tra i sistemi. Il DPS sostenuto delle armi dipende dall'energia che ricevono; il resto viene bilanciato automaticamente.",
        "families": {
          "weapon": "Armi",
          "shield": "Scudi",
          "engine": "Motore",
          "radar": "Radar",
          "coolers": "Refrigeranti",
          "qdrive": "Motore Quantum",
          "qed": "QED",
          "emp": "EMP",
          "lifeSupport": "Supporto vitale",
          "miningLaser": "Laser da estrazione",
          "salvage": "Recupero",
          "tractorBeam": "Raggio traente",
          "towingbeam": "Raggio di traino"
        }
      },
      "defense": {
        "title": "Difesa",
        "shieldHp": "HP scudi",
        "shieldHpSub": "%{count} generatori",
        "shieldRegen": "Rigenerazione",
        "shieldResistances": "Resistenza",
        "shieldAbsorption": "Assorbimento",
        "shieldFaces": "Facce dello scudo",
        "armor": "Corazza",
        "deflection": "Deflessione",
        "armorReduction": "Riduzione del danno",
        "armorSelfResistance": "Autoresistenza",
        "armorSignature": "Firma",
        "countermeasures": "Contromisure",
        "countermeasureDuration": "Durata",
        "countermeasure": {
          "decoy": "Esca",
          "noise": "Disturbo"
        },
        "damageType": {
          "physical": "Fis.",
          "energy": "Energia",
          "distortion": "Distors.",
          "thermal": "Termico"
        },
        "signature": {
          "electromagnetic": "EM",
          "infrared": "IR",
          "crossSection": "CS"
        },
        "hint": "Valori di scudi, corazza e contromisure della configurazione predefinita. Un assorbimento inferiore al 100% significa che quel tipo di danno raggiunge lo scafo mentre gli scudi sono ancora attivi.",
        "openDeflectionCheck": "Verifica deflessione"
      },
      "penetrationCheck": {
        "title": "Verifica penetrazione",
        "intro": "— quali navi possono perforare le sue armi?",
        "noWeapons": "Questa configurazione non monta cannoni con danno per colpo da verificare.",
        "weapons": "Armi",
        "shieldHealth": "Salute degli scudi del bersaglio",
        "armorHealth": "Salute della corazza del bersaglio",
        "ship": "Nave",
        "hoverHint": "Passa sopra una nave per il dettaglio per arma.",
        "note": "Ogni cannone selezionato viene confrontato con gli scudi e la deflessione della corazza di ogni nave secondo le stesse regole della verifica deflessione; una nave è perforata quando uno qualsiasi di essi passa, e viene ordinata in base al cannone che si avvicina di più. Le navi senza corazza sono escluse, perché non c'è una soglia da superare.",
        "sortBy": "Ordina per",
        "sort": {
          "margin": "Margine",
          "ttk": "Tempo di distruzione"
        },
        "ttk": "TTK",
        "effectiveHp": "PV effettivi",
        "shieldsDown": "Scudi abbattuti",
        "ttkNote": "Il tempo di distruzione usa il danno sostenuto al secondo dei cannoni selezionati, con la ripartizione di energia attuale, a partire dalla salute di scudo e corazza impostata sopra. Gli scudi subiscono il danno che assorbono, meno la loro resistenza, e passano il resto alla corazza, che lo subisce finché non cede e poi lo passa allo scafo; la distorsione consuma solo gli scudi. Gli scudi si rigenerano solo mentre ogni cannone è in pausa più a lungo del loro ritardo di rigenerazione, e una volta abbattuti restano abbattuti. I PV effettivi sono il danno grezzo di un tipo necessario per distruggere la nave, senza deflessione. I raggi, contrassegnati TTK, contano solo per il tempo di distruzione: la corazza non li devia mai e, senza alfa per colpo, non entrano nel margine. I missili sono esclusi."
      },
      "deflectionCheck": {
        "title": "Verifica della deflessione",
        "intro": "— quali armi perforano le sue difese?",
        "noArmor": "Questa nave non ha corazza, quindi non viene deflesso nulla.",
        "allSizes": "Tutte",
        "deflected": "deflessi",
        "pierce": "perforano",
        "weapon": "Arma",
        "boundary": "Soglia di deflessione",
        "alpha": "Alpha",
        "threshold": "Soglia superata",
        "absorbed": "assorbiti",
        "versus": "contro",
        "hoverHint": "Passa il mouse su un'arma per il dettaglio per tipo di danno.",
        "note": "L'alpha viene confrontato per singolo proiettile, dopo l'assorbimento dello scudo — un'arma perfora quando supera la deflessione su almeno un tipo di danno. I tipi che gli scudi assorbono completamente non raggiungono mai la corazza, perciò sono indicati come assorbiti anziché deflessi: fermati dallo scudo, non dallo scafo. L'assorbimento dello scudo viene interpolato nell'intervallo min-max dichiarato in base alla salute dello scudo, e la deflessione della corazza scala linearmente con la salute della corazza. I raggi laser sono esclusi: infliggono danno continuo, quindi non c'è un alpha per colpo da verificare.",
        "margin": "Margine",
        "reachesArmor": "Raggiunge la corazza",
        "stoppedByShields": "Assorbito dallo scudo",
        "verdict": {
          "absorbed": "Assorbito",
          "deflected": "Deflesso",
          "pierces": "Perforato"
        },
        "shieldHealth": "Salute scudi",
        "armorHealth": "Salute corazza",
        "absorb": "Assorb.",
        "defl": "Defl.",
        "type": "Tipo",
        "size": "Dimensione"
      },
      "hull": {
        "category": {
          "vital": "Vitali",
          "secondary": "Secondarie",
          "breakable": "Distruttibili",
          "subpart": "Sottoparti",
          "cosmetic": "Estetiche"
        },
        "composition": "Composizione dello scafo",
        "door": "Porta",
        "doors": "Porte",
        "doorsNote": "Le porte interne distruttibili sono un'area a sé — hanno una salute propria e non fanno parte degli HP dello scafo.",
        "doorsSub": "%{count} distruttibili",
        "hint": "Gli HP dello scafo sono la somma della salute di tutte le parti.",
        "hullHp": "HP scafo",
        "hullHpSub": "totale su tutte le parti",
        "integrity": "Integrità dello scafo",
        "noHp": "nessun HP",
        "parts": "Parti dello scafo",
        "partsNote": "Le parti sono ordinate per salute; le parti estetiche (porte, scale, portelli) non hanno una salute propria. I file di gioco non espongono alcun legame padre/figlio, quindi questo è un elenco piatto e non un albero strutturale.",
        "partsSub": "su %{count} categorie",
        "partsTree": "Parti · damageMax",
        "showParts": "Mostra le parti dello scafo",
        "title": "Scafo",
        "totalHp": "HP scafo totali"
      },
      "manufacturer": {
        "shortName": "Nome breve",
        "shipyard": "Cantiere navale",
        "longName": "Nome completo",
        "code": "Codice",
        "logo": "Logo",
        "logoOverridden": "Logo (sovrascritto)",
        "icon": "Icona (file di gioco)",
        "iconOverridden": "Icona (sovrascritta)",
        "scRef": "SC Ref"
      },
      "announcement": {
        "title": "Titolo",
        "body": "Testo",
        "discordParts": "Messaggi Discord",
        "socialParts": "Post social",
        "link": "Link",
        "notifyUsers": "Notifica in-app",
        "postDiscord": "Canale aggiornamenti Discord",
        "postBluesky": "Bluesky",
        "schedule": "Pianifica",
        "publishAt": "Invia il"
      },
      "fundingGoal": {
        "title": "Titolo",
        "description": "Descrizione",
        "amount": "Importo",
        "currency": "Valuta",
        "effectiveFrom": "In vigore dal",
        "endedAt": "Terminato il"
      },
      "supporterContribution": {
        "name": "Nome del sostenitore",
        "user": "Account collegato",
        "amount": "Importo",
        "currency": "Valuta",
        "anonymous": "Anonimo",
        "recurring": "Ricorrente",
        "startedAt": "Iniziato il",
        "endedAt": "Terminato il",
        "payerEmail": "Email del pagante",
        "claimKey": "Token sostenitore",
        "linkedVia": "Collegato tramite",
        "source": "Origine",
        "note": "Nota interna",
        "stats": {
          "total": "Totale",
          "count": "Contributi",
          "currentMonth": "Questo mese",
          "currentMonthCount": "%{count} contributi",
          "recurringCount": "Ricorrenti",
          "anonymousCount": "Anonimi"
        },
        "chart": {
          "contributions": "Contributi",
          "goal": "Obiettivo"
        }
      },
      "itemPrice": {
        "price": "Prezzo",
        "location": "Posizione",
        "locationUrl": "URL posizione"
      },
      "video": {
        "url": "URL",
        "videoType": "Tipo"
      },
      "modelModule": {
        "name": "Nome",
        "description": "Descrizione",
        "price": "Prezzo",
        "pledgePrice": "Prezzo Pledge",
        "productionStatus": "Stato di Produzione",
        "scKey": "SC Key",
        "storeImage": "Immagine Negozio",
        "active": "Attivo?",
        "hidden": "Nascosto?"
      },
      "dockAddition": {
        "model": "Nave",
        "hint": "Navi che questo attracco ospita e che la sua classe non copre.",
        "empty": "navi indicate"
      },
      "dockCapacity": {
        "ladder": "Scala",
        "size": "Classe",
        "quantity": "Quantità",
        "display": "Mostra come etichetta",
        "hint": "Per cosa è costruito l'attracco. Le voci sono alternative, non una somma.",
        "empty": "voci di capacità"
      },
      "dockCapacityLadders": {
        "ship": "Navi",
        "vehicle": "Veicoli"
      },
      "vehicleSizes": {
        "extra_extra_small": "Extra extra piccolo (XXS)",
        "extra_small": "Extra piccolo (XS)",
        "small": "Piccolo (S)",
        "medium": "Medio (M)",
        "large": "Grande (L)",
        "extra_large": "Extra grande (XL)",
        "extra_extra_large": "Extra extra grande (XXL)"
      },
      "dock": {
        "name": "Nome",
        "dockType": "Tipo di dock",
        "shipSize": "Dimensione nave",
        "access": "Accesso",
        "length": "Lunghezza",
        "beam": "Larghezza",
        "height": "Altezza",
        "unmeasured": "non misurato"
      },
      "modelPosition": {
        "name": "Nome",
        "positionType": "Tipo di posizione",
        "source": "Fonte",
        "position": "Ordinamento",
        "types": {
          "pilot": "Pilota",
          "copilot": "Copilota",
          "turret_gunner": "Artigliere di torretta",
          "engineer": "Ingegnere",
          "gunner": "Artigliere",
          "loadmaster": "Responsabile del carico",
          "passenger": "Passeggero",
          "operator": "Operatore",
          "custom": "Personalizzata"
        }
      },
      "modelUpgrade": {
        "name": "Nome",
        "description": "Descrizione",
        "pledgePrice": "Prezzo Pledge",
        "active": "Attivo?",
        "hidden": "Nascosto?"
      },
      "modelModulePackage": {
        "name": "Nome",
        "description": "Descrizione",
        "pledgePrice": "Prezzo Pledge",
        "modules": "Moduli",
        "active": "Attivo?",
        "hidden": "Nascosto?"
      },
      "cargoHold": {
        "offsetX": "Offset X (SCU)",
        "offsetY": "Offset Y (SCU)",
        "offsetZ": "Offset Z (SCU)",
        "rotation": "Rotazione (°)"
      },
      "modelLoaner": {
        "hidden": "Nascosto?",
        "loanerModel": "Modello in prestito"
      },
      "modelSnubCraft": {
        "snubCraft": "Snub Craft"
      },
      "modelPaint": {
        "hidden": "Nascosto?",
        "active": "Attivo?",
        "onSale": "In vendita",
        "pledgePrice": "Prezzo Pledge",
        "productionStatus": "Stato di produzione",
        "productionNote": "Nota di produzione",
        "copyHint": "Seleziona la nave di destinazione su cui copiare questa verniciatura. I dati della verniciatura non vengono modificati durante la copia.",
        "bulkCopyHint": "Seleziona la nave di destinazione su cui copiare queste %{count} verniciature. I dati delle verniciature non vengono modificati durante la copia.",
        "copySameModel": "La nave di destinazione deve essere diversa da quella di origine."
      },
      "component": {
        "temperature": {
          "minCooling": "Raffredda da",
          "overheat": "Surriscalda a",
          "warning": "Avviso a",
          "recovery": "Si riprende a",
          "misfireRange": "Intervallo di malfunzionamento",
          "irStart": "IR da",
          "irPerKelvin": "IR per K"
        },
        "misfire": {
          "heat": "Calore",
          "distortion": "Distorsione",
          "damage": "Danno",
          "wear": "Usura",
          "window": "Finestra",
          "hint": "Il livello di ogni stato da cui il componente può iniziare a malfunzionare, come lo indicano i file di gioco."
        },
        "availability": {
          "retired": "I prezzi sono rilevati per la build su cui si trova il catalogo, e questo pezzo non ne fa parte.",
          "craftedOnly": "Nessun terminale lo vende: si produce con la ricetta qui sotto.",
          "none": "Nessun terminale lo compra o lo vende."
        },
        "notRecordedYet": "Registrato solo da quando è iniziato il tracciamento, quindi un componente può non avere nulla.",
        "size": "Dimensione: %{size}",
        "grade": "Grado",
        "hidden": "Nascosto?",
        "componentType": "Tipo componente",
        "componentSubType": "Sottotipo componente",
        "scKey": "SC Key",
        "scRef": "SC Ref",
        "storeImage": "Store Image",
        "itemClass": "Classe",
        "category": "Categoria",
        "subType": "Sottotipo",
        "retired": "Non più presente nella build attuale",
        "noMetrics": "Nessun dato registrato per questo componente.",
        "durability": {
          "health": "Salute",
          "mass": "Massa",
          "physical": "Fisico",
          "energy": "Energia",
          "distortion": "Distorsione",
          "thermal": "Termico",
          "biochemical": "Biochimico",
          "stun": "Stordimento",
          "repairTime": "Tempo di riparazione",
          "repairsTo": "Ripara fino a",
          "maxRepairs": "Riparazioni max",
          "disableAt": "Disattivato a",
          "warningAt": "Avviso a",
          "recoversBelow": "Si riprende sotto",
          "decayRate": "Velocità di dissipazione",
          "decayDelay": "Ritardo di dissipazione"
        },
        "durabilityChanges": {
          "health": "Salute",
          "mass": "Massa (kg)",
          "resistancesPhysical": "Danni fisici subiti",
          "resistancesEnergy": "Danni da energia subiti",
          "resistancesDistortion": "Danni da distorsione subiti",
          "resistancesThermal": "Danni termici subiti",
          "resistancesBiochemical": "Danni biochimici subiti",
          "resistancesStun": "Danni da stordimento subiti",
          "selfRepairTime": "Tempo di autoriparazione (s)",
          "selfRepairHealthRatio": "L'autoriparazione ripristina a",
          "selfRepairMaxRepairs": "Autoriparazioni max",
          "distortionMaximum": "Soglia di spegnimento per distorsione",
          "distortionWarningRatio": "Soglia di avviso distorsione",
          "distortionRecoveryRatio": "Soglia di recupero distorsione",
          "distortionDecayRate": "Velocità di dissipazione distorsione (/s)",
          "distortionDecayDelay": "Ritardo di dissipazione distorsione (s)"
        }
      },
      "hardpoint": {
        "legend": {
          "headline": "Legenda",
          "slotTaken": "Slot preso",
          "slotAvailable": "Slot libero"
        },
        "size": "Dimensione",
        "rackSize": "Dimensione Rack",
        "details": "Dettagli",
        "group": "Gruppo",
        "thrusters": {
          "thrust": "Spinta",
          "subTypes": {
            "JointThruster": "Joint",
            "FixedThruster": "Fix",
            "FlexThruster": "Flex",
            "Retro": "Fix",
            "Light": "Light"
          },
          "fuelBurn": "Consumo di carburante",
          "mode": "Modalità",
          "vtolOnly": "Solo VTOL",
          "vectorPitch": "Vettorizzazione beccheggio",
          "vectorYaw": "Vettorizzazione imbardata"
        },
        "refuelBoom": {
          "captureRadius": "Raggio di aggancio",
          "fuelFlowRate": "Portata carburante",
          "quantumFuelFlowRate": "Portata carburante Quantum"
        },
        "controllers": {
          "faceType": "Tipo di scudo",
          "faces": {
            "bubble": "Bolla",
            "quadrant": "Quadranti"
          },
          "reconfigurationCooldown": "Riconfigurazione",
          "armedMissiles": "Missili armati",
          "launchCooldown": "Ricarica di lancio",
          "lockAngle": "Angolo di aggancio"
        },
        "countermeasureStats": {
          "duration": "Durata",
          "spawnDelay": "Si dispiega dopo",
          "infrared": "Firma IR",
          "electromagnetic": "Firma EM",
          "crossSection": "Sezione trasversale"
        },
        "turrets": {
          "turnRate": "Velocità di rotazione",
          "control": "Controllo",
          "yawRange": "Escursione d'imbardata",
          "pitchRange": "Escursione di beccheggio",
          "limitsVary": "in base alla rotazione",
          "gunPorts": "Slot armi"
        },
        "weapons": {
          "dps": "DPS",
          "burstDps": "DPS di raffica",
          "sustainedDps": "DPS sostenuto",
          "efficiency": "Efficienza",
          "penetration": "Penetrazione",
          "fireRate": "Cadenza di fuoco",
          "speed": "Velocità",
          "range": "Gittata",
          "ammo": "Munizioni",
          "ammoCost": "Costo munizioni",
          "magazineDamage": "Danno del caricatore",
          "timeToEmpty": "Tempo per svuotare",
          "spread": "Dispersione",
          "spreadFirstShot": "Dispersione primo colpo",
          "spreadPerShot": "Dispersione/colpo",
          "spreadRecovery": "Recupero dispersione",
          "pool": "Riserva energetica",
          "maxRegen": "Regen max/s",
          "costPerShot": "Energia/colpo",
          "heatPerShot": "Calore/colpo",
          "heatPerSecond": "Calore/s",
          "gimbalFireRate": "Cadenza (gimbal)",
          "gimbalSpread": "Dispersione (gimbal)",
          "spreadMin": "min.",
          "spreadMax": "max.",
          "aimAssist": "Assistenza alla mira",
          "closeAimAssist": "Assistenza a corto raggio",
          "chargeTime": "Tempo di carica",
          "fullDamageRange": "Gittata DMG pieno",
          "zeroDamageRange": "Gittata DMG nullo",
          "damagePhysical": "Fisico",
          "damageEnergy": "Energia",
          "damageDistortion": "Distorsione",
          "damageThermal": "Termico"
        },
        "missiles": {
          "damage": "Danno",
          "speed": "Velocità",
          "range": "Gittata",
          "lockRange": "Gittata di aggancio",
          "lockTime": "Tempo di aggancio",
          "trackingSignal": "Tracciamento",
          "lockAngle": "Cono di aggancio",
          "signalResilience": "Resistenza al segnale",
          "boostPhase": "Fase di spinta",
          "terminalPhase": "Fase terminale",
          "lifetime": "Durata",
          "fuel": "Carburante",
          "dumbfire": "Fuoco non guidato",
          "dumbfireAllowed": "Consentito",
          "dumbfireBlocked": "Non consentito",
          "blastRadius": "Raggio d'esplosione",
          "armTime": "Tempo d'innesco",
          "safetyDistance": "Distanza di sicurezza"
        },
        "bombs": {
          "maxDropAngle": "Angolo di sgancio max."
        },
        "missileRacks": {
          "launchDelay": "Ritardo di lancio",
          "ignition": "Accensione del motore",
          "ignitesOnRack": "Sul supporto",
          "ignitesAfterRelease": "Dopo lo sgancio"
        },
        "tractorBeams": {
          "maxForce": "Forza max",
          "minForce": "Forza min",
          "range": "Gittata",
          "cone": "Cono",
          "tetherBreak": "Rottura del vincolo",
          "cargoForce": "Forza sul carico",
          "cargoRange": "Gittata sul carico",
          "towForce": "Forza di traino",
          "towDistance": "Gittata di traino",
          "quantumTowMass": "Limite massa QT",
          "rotationSpeed": "Rotazione",
          "moveSpeed": "Velocità di spostamento"
        },
        "shields": {
          "hp": "HP",
          "regen": "Regen",
          "regenTime": "Tempo di regen",
          "downedRegenDelay": "Ritardo da abbattuto",
          "damagedRegenDelay": "Ritardo da danneggiato",
          "resistancePhysical": "Res. fis.",
          "resistanceEnergy": "Res. energia",
          "resistanceDistortion": "Res. distors.",
          "decay": "Decadimento",
          "absorption": {
            "physical": "Assorbimento fisico",
            "energy": "Assorbimento energetico",
            "distortion": "Assorbimento distorsione"
          }
        },
        "coolers": {
          "coolingRate": "Raffreddamento"
        },
        "powerPlants": {
          "output": "Output",
          "pips": "Pips"
        },
        "flightControllers": {
          "scmSpeed": "Velocità SCM",
          "boostSpeed": "Velocità boost",
          "navSpeed": "Velocità Nav",
          "rotation": "Beccheggio / Imbardata / Rollio",
          "boostedRotation": "Beccheggio / Imbardata / Rollio con boost",
          "boostCapacity": "Capacità boost",
          "boostRegen": "Rigenerazione boost",
          "boostRegenDelay": "Ritardo rigenerazione boost",
          "boostRamp": "Avvio / rilascio boost"
        },
        "quantumDrives": {
          "speed": "Velocità",
          "range": "Autonomia",
          "fuelConsumption": "Consumo",
          "spoolUpTime": "Preparazione",
          "cooldownTime": "Recupero",
          "splineSpeed": "Orbita",
          "accel": "Accel.",
          "engageSpeed": "Velocità di aggancio",
          "calibrationRate": "Velocità di calibrazione",
          "disconnectRange": "Distanza di disconnessione",
          "interdictionTime": "Durata dell'interdizione",
          "splineAccel": "Accelerazione in orbita",
          "splineSpoolUpTime": "Avvio in orbita",
          "splineCooldownTime": "Raffreddamento in orbita",
          "splineInterdictionTime": "Interdizione in orbita",
          "jumpHeat": "Calore di salto"
        },
        "jumpDrives": {
          "fuelEfficiency": "Efficienza carburante",
          "alignRate": "Vel. allineamento",
          "tuneRate": "Vel. sintonizzazione",
          "alignDecay": "Decadimento allineamento",
          "tuneDecay": "Decadimento sintonizzazione",
          "exitSpeed": "Velocità di uscita",
          "maxTunnelSpeed": "Velocità max nel tunnel",
          "respoolTime": "Riavvio"
        },
        "radar": {
          "aimAssistRange": "Gittata assistenza",
          "ir": "IR",
          "em": "EM",
          "cs": "CS",
          "rs": "RS",
          "passive": "Rilevamento passivo",
          "active": "Rilevamento attivo",
          "aimAssistBuffer": "Margine di assistenza",
          "sensitivityModifier": "Modificatore di sensibilità",
          "contactGroups": {
            "GroundVehicle": "Veicoli terrestri"
          }
        },
        "armor": {
          "hp": "HP",
          "physical": "Fisico",
          "energy": "Energia",
          "distortion": "Distorsione",
          "thermal": "Termico",
          "deflectPhysical": "Defl. fisico",
          "deflectEnergy": "Defl. energia",
          "selfPhysical": "Autores. fis.",
          "selfEnergy": "Autores. energia"
        },
        "fuelIntakes": {
          "pushRate": "Portata di spinta",
          "minRate": "Portata min."
        },
        "sources": {
          "game_files": "File di gioco",
          "ship_matrix": "Ship Matrix"
        },
        "density": {
          "title": "Vista",
          "compact": "Compatta",
          "expanded": "Estesa"
        },
        "fuelTanks": {
          "hydrogen": "Serbatoio carburante idrogeno",
          "quantum": "Serbatoio carburante Quantum"
        },
        "jumpDrive": "Motore di salto",
        "maxContainerSize": "Dimensione max. container",
        "groups": {
          "avionic": "Avionica",
          "system": "Sistema",
          "propulsion": "Propulsione",
          "thruster": "Propulsori",
          "weapon": "Armamenti",
          "defense": "Difesa",
          "other": "Altro",
          "auxiliary": "Ausiliario",
          "seat": "Sedili",
          "external_fuel_tank": "Serbatoi di carburante esterni",
          "refuel_boom": "Braccio di rifornimento"
        },
        "types": {
          "radar": "Radar",
          "computers": "Computer",
          "power_plants": "Generatori",
          "coolers": "Refrigeranti",
          "shield_generators": "Generatori di Scudi",
          "fuel_intakes": "Bocchettoni carburante",
          "fuel_tanks": "Serbatoi Carburante",
          "quantum_drives": "Drive Quantici",
          "jump_modules": "Moduli di salto",
          "jumpdrive": "Moduli di salto",
          "quantum_fuel_tanks": "Serbatoi di Carburante Quantico",
          "main_thrusters": "Propulsori Principali",
          "maneuvering_thrusters": "Propulsori di Manovra",
          "weapons": "Armamenti",
          "turrets": "Torrette",
          "missiles": "Missili",
          "utility_items": "Oggetti di utilità",
          "utility": "Oggetti di utilità",
          "emp": "EMP",
          "qed": "QED"
        },
        "moduleSlotEmpty": "— Seleziona modulo —",
        "selectModule": "Seleziona modulo",
        "moduleStock": "Come consegnato",
        "moduleStockHint": "Slot lasciato come arriva la nave",
        "categories": {
          "radar": "Radar",
          "armor": "Corazza",
          "relay": "Relè",
          "countermeasures": "Contromisure",
          "lifesupport": "Supporto vitale",
          "selfdestruct": "Autodistruzione",
          "batteries": "Batterie",
          "computers": "Computer",
          "powerplant": "Centrali energetiche",
          "cooler": "Raffreddatori",
          "module": "Moduli",
          "shieldgenerator": "Generatori di scudi",
          "fuel_intakes": "Prese di carburante",
          "fueltanks": "Serbatoi di carburante",
          "external_fuel_tanks": "Serbatoi di carburante esterni",
          "refuel_boom": "Braccio di rifornimento",
          "quantumdrive": "Motori Quantum e moduli di salto",
          "jump_modules": "Moduli di salto",
          "jumpdrive": "Moduli di salto",
          "quantum_fuel_tanks": "Serbatoi carburante Quantum",
          "main_thrusters": "Propulsori principali",
          "maneuvering_thrusters": "Propulsori di manovra",
          "retro_thrusters": "Propulsori retro",
          "vtol_thrusters": "Propulsori VTOL",
          "weapons": "Armi",
          "weapon_mounts": "Supporti armi",
          "turret": "Torrette",
          "missiles": "Missili",
          "missile_racks": "Rack missili",
          "utility_items": "Oggetti di utilità",
          "utility": "Oggetti di utilità",
          "emp": "EMP",
          "quantumenforcementdevice": "QED",
          "salvagefillerstation": "Stazione di riempimento salvataggio",
          "cargogrid": "Griglia di carico",
          "controller": "Lame di volo",
          "seat": "Sedili",
          "thrusters": "Propulsori",
          "bombcompartments": "Vani bombe"
        },
        "name": "Nome",
        "category": "Categoria",
        "source": "Fonte",
        "powerConsumption": "Consumo di energia",
        "powerMinimumFraction": "Consumo a riposo",
        "signatureEm": "Firma EM",
        "signatureIr": "Firma IR",
        "mining": {
          "fracturePower": "Potenza di frattura",
          "extractionPower": "Potenza di estrazione",
          "range": "Portata",
          "chargeTime": "Carica / scarica",
          "moduleSlots": "Slot modulo",
          "activation": "Tipo",
          "active": "Attivo",
          "passive": "Passivo",
          "charges": "Utilizzi",
          "duration": "Durata",
          "modifiers": {
            "instability": "Instabilità",
            "resistance": "Resistenza",
            "optimalChargeWindow": "Finestra di carica ottimale",
            "optimalChargeRate": "Velocità di carica ottimale",
            "catastrophicChargeRate": "Velocità di carica critica",
            "shatterDamage": "Danno da frantumazione",
            "inertMaterials": "Materiali inerti"
          }
        },
        "salvage": {
          "salvageSpeed": "Velocità di recupero",
          "radius": "Raggio del fascio",
          "extractionEfficiency": "Efficienza di estrazione"
        },
        "utility": {
          "capacity": "Capacità"
        },
        "selfDestruct": {
          "damage": "Danno",
          "radius": "Raggio d'esplosione",
          "time": "Tempo di innesco"
        },
        "quantumEnforcement": {
          "jammerRange": "Portata del disturbatore",
          "pulseRadius": "Raggio dell'impulso",
          "chargeTime": "Tempo di carica",
          "cooldownTime": "Recupero"
        },
        "emp": {
          "distortionDamage": "Danno da distorsione",
          "radius": "Raggio",
          "chargeTime": "Tempo di carica",
          "unleashTime": "Tempo di rilascio",
          "cooldownTime": "Raffreddamento"
        },
        "lifeSupport": {
          "output": "Produzione"
        },
        "powerRanges": "Curva di potenza (bassa / media / alta)",
        "powerSegments": "seg."
      },
      "blank": {
        "propulsion": "Nessun Propulsione presente",
        "modular": "Nessun modulare presente",
        "fleetInvites": "Nessun Invito presente"
      },
      "user": {
        "hangarDefaultSort": "Ordine predefinito",
        "hangarDefaultSortInfo": "Trascina una nave per la sua maniglia per riordinarla. Disponibile finché l'ordine personalizzato è attivo e nessun filtro è impostato.",
        "hangarDefaultSortOptions": {
          "standard": "Standard (nave ammiraglia prima, poi nome)",
          "asc": "%{field}, crescente",
          "desc": "%{field}, decrescente"
        },
        "rsiHandle": "Handle",
        "rsiHandleVerified": "Verificato tramite Citizen iD",
        "rsiHandleVerifiedViaProfile": "Verificato tramite il profilo RSI",
        "rsiVerification": {
          "title": "Verifica il tuo handle RSI",
          "token": "Codice di verifica",
          "verifiedSince": "Verificato dal %{date}",
          "openProfileSettings": "Modifica il tuo profilo RSI",
          "steps": {
            "copy": "Copia il tuo codice di verifica",
            "paste": "Incollalo nella breve bio del tuo profilo RSI. Puoi rimuoverlo una volta verificato l’handle.",
            "check": "Controlla la pagina cittadino di %{handle}"
          },
          "extension": {
            "title": "Verifica con l’estensione FleetYards Sync",
            "verify": "Verifica con l’estensione",
            "description": "L’estensione aggiunge il tuo codice alla bio dell’account RSI con cui questo browser ha effettuato l’accesso, controlla la tua pagina cittadino e poi rimuove il codice.",
            "detecting": "Ricerca dell’estensione FleetYards Sync",
            "install": "Installa l’estensione FleetYards Sync per verificare il tuo handle con un clic.",
            "update": "Aggiorna l’estensione FleetYards Sync per verificare il tuo handle con un clic: la versione installata non lo supporta ancora.",
            "handleMismatch": "Questo browser ha effettuato l’accesso a RSI come %{rsiHandle}, non come %{handle}. Accedi a RSI come %{handle} oppure verifica a mano qui sotto.",
            "notSignedIn": "Accedi a RSI in questo browser per verificare con l’estensione, oppure verifica a mano qui sotto.",
            "bioTooLong": "La tua bio RSI è troppo lunga per aggiungere il codice. Accorciala oppure verifica a mano qui sotto.",
            "bioUnreadable": "La tua bio RSI contiene una formattazione che l’estensione non può mantenere invariata. Verifica a mano qui sotto.",
            "failed": "L’estensione non è riuscita ad aggiornare la tua bio RSI. Riprova oppure verifica a mano qui sotto.",
            "removeFailed": "L’estensione non è riuscita a rimuovere il codice dalla tua bio RSI. Rimuovilo a mano.",
            "manual": "Oppure verifica a mano:"
          },
          "statuses": {
            "pending": "Controllo della tua pagina cittadino…",
            "token_missing": "Il codice non è ancora nella tua bio. RSI può impiegare qualche minuto a mostrare una modifica.",
            "handle_mismatch": "La pagina restituita da RSI appartiene a un altro handle.",
            "not_found": "RSI non ha nessun cittadino con questo handle.",
            "failed": "Non è stato possibile controllare la tua pagina cittadino. Riprova tra un minuto."
          }
        },
        "location": "Posizione",
        "currentSystem": "Posizione attuale nel gioco",
        "tester": "Tester?",
        "maintainer": "Manutentore?",
        "avatar": "Avatar",
        "unconfirmedEmail": "Email non confermata",
        "saleNotify": "Voglio ricevere notifiche di vendita",
        "publicHangar": "Hangar Pubblico abilitato",
        "publicHangarLoaners": "Mostra suggerimento Navi di Cortesia su Hangar Pubblico",
        "publicHangarStats": "Statistiche hangar pubbliche abilitate",
        "publicWishlist": "Lista dei desideri pubblica abilitata",
        "hideOwner": "Nascondi proprietà per le flotte",
        "tracking": "Consenti analisi di utilizzo anonime",
        "showOnlineStatus": "Mostra quando sono online",
        "onlineStatus": "Stato online",
        "online": "Online",
        "offline": "Offline",
        "lastActiveAt": "Ultima attività",
        "confirmedAt": "Confermato il",
        "dateFormat": "Formato data",
        "dateFormats": {
          "dmy_dots": "31.12.2026",
          "dmy_slash": "31/12/2026",
          "mdy_slash": "12/31/2026",
          "ymd_dash": "2026-12-31"
        },
        "friendsHangar": "Hangar visibile agli amici",
        "friendsHangarStats": "Statistiche dell'hangar visibili agli amici",
        "friendsWishlist": "Lista dei desideri visibile agli amici"
      },
      "adminUser": {
        "superAdmin": "Super admin",
        "passwordConfirmation": "Conferma password"
      },
      "vehicle": {
        "customOrder": "Personalizzato",
        "name": "Nome",
        "states": "Stati",
        "serial": "Seriale",
        "owner": "comandata da",
        "flagship": "Ammiraglia",
        "wanted": "Desiderato",
        "loaner": "Prestito",
        "bundled": "In bundle",
        "bundledWith": "In bundle con %{parent}",
        "public": "Pubblicamente Visibile",
        "fullPublic": "Pubblicamente Visibile incluso il nome",
        "publicShort": "Pubblico",
        "nameVisible": "Pubblicamente Visibile",
        "hidden": "Nascosto?",
        "saleNotify": "Voglio ricevere notifiche di messa in vendita",
        "hangarGroups": "Gruppi",
        "modelPaintSelect": {
          "nullablePrompt": "Seleziona una Paint",
          "label": "Verniciatura"
        },
        "bulkGroupEdit": {
          "hint": "I Gruppi esistenti saranno sovrascritti!"
        },
        "hasLoaners": "Navi in comodato",
        "boughtViaSelect": {
          "label": "Acquistato tramite"
        }
      },
      "image": {
        "active": "Attivo?",
        "background": "Utilizzare come background?",
        "caption": "Didascalia",
        "enabled": "Abilitato?",
        "file": "File immagine",
        "global": "Globale?",
        "delete": "Elimina",
        "start": "Avvia",
        "cancel": "Annulla",
        "processing": "Elaborazione...",
        "error": "Errore",
        "name": "Nome",
        "size": "Dimensione file",
        "dropzone": "Trascina qui le immagini",
        "cancelUpload": "Annulla il caricamento",
        "startUpload": "Avvia caricamento",
        "selectImages": "Aggiungi immagini...",
        "selectFolder": "Aggiungi una cartella..."
      },
      "signup": {
        "link": "Non hai un Account?",
        "privacyPolicy": "Creando un account FleetYards, accetti la nostra"
      },
      "privacyPolicy": "Informativa sulla privacy",
      "login": "Username o e-mail",
      "username": "Nome utente",
      "twoFactorCode": "Codice due-fattori",
      "confirmationCode": "Codice di conferma",
      "email": "E-mail",
      "avatar": "Avatar",
      "alreadyRegistered": "Hai già un account?",
      "password": "Password",
      "passwordConfirmation": "Conferma Password",
      "rememberMe": "Resta Collegato",
      "emptyList": "Nessun %{name} presente",
      "all": "Tutto",
      "supportUs": "Supporta FleetYards.net",
      "account": {
        "destroyInfo": "Se si desidera eliminare il tuo account e rimuovere tutte le informazioni da Fleetyards,nett e i suoi servizi fare clic sul pulsante qui sotto. Sii consapevole che questa è un'azione permanente e non può essere annullata.",
        "calendarSubscription": {
          "intro": "Genera un link privato per aggiungere gli eventi a cui ti sei iscritto alla tua app calendario personale (Apple Calendar, Google Calendar, Outlook).",
          "howTo": "Incolla il link nella tua app calendario sotto \"Iscriviti a un calendario\" o \"Aggiungi tramite URL\". Chiunque abbia questo link può vedere gli eventi a cui ti sei iscritto — tienilo privato."
        },
        "supporterNomination": {
          "label": "Supporto alla flotta",
          "hint": "I suoi membri ottengono le funzioni di flotta finché una donazione è attiva. Puoi scegliere prima di donare.",
          "perDonation": "Per donazione",
          "perDonationHint": "Una singola donazione può sostenere una flotta diversa da quella abituale.",
          "fleet": "Flotta sostenuta"
        },
        "supporterClaimKey": {
          "signedOut": "Accedi per ottenere la tua chiave personale da sostenitore.",
          "patreonNote": "collegato tramite la tua email, nessuna chiave necessaria",
          "label": "La tua chiave",
          "hint": "Incollala nel messaggio di un pagamento PayPal, Ko-fi o Buy me a coffee e verrà collegato al tuo account. Su Patreon il collegamento avviene tramite email."
        }
      },
      "filters": {
        "locations": {
          "name": "Cerca luoghi",
          "system": "Sistema",
          "parent": "All’interno di",
          "kind": "Tipo",
          "starmap": "Mappa di gioco",
          "shownOnStarmap": "Visibile sulla mappa",
          "hiddenOnStarmap": "Nascosto sulla mappa"
        },
        "components": {
          "name": "Nome",
          "buyPriceGt": "Prezzo d'acquisto >=",
          "buyPriceLt": "Prezzo d'acquisto <=",
          "sellPriceGt": "Prezzo di vendita >=",
          "sellPriceLt": "Prezzo di vendita <=",
          "storeImageBlank": "Senza immagine negozio?",
          "description": "Descrizione",
          "manufacturer": "Produttore",
          "category": "Categoria",
          "subType": "Sottotipo"
        },
        "shops": {
          "name": "Nome",
          "type": "Tipo",
          "model": "Nave",
          "equipment": "Equipaggiamento",
          "component": "Componente",
          "commodity": "Prodotto",
          "commodityType": "Tipo Di Prodotto"
        },
        "shopCommodities": {
          "commodityType": "Tipo Di Prodotto",
          "equipment": "Equipaggiamento",
          "component": "Componente",
          "commodity": "Prodotto",
          "model": "Nave",
          "name": "Nome"
        },
        "shopItems": {
          "category": "Categoria",
          "subCategory": "Sottocategoria",
          "name": "Nome",
          "manufacturer": "Produttore"
        },
        "stations": {
          "name": "Nome",
          "type": "Tipo di Stazione",
          "shops": "Negozi",
          "docks": "Moli"
        },
        "vehicles": {
          "name": "Nome o nome della Nave",
          "lengthLt": "Lunghezza <=",
          "lengthGt": "Lunghezza >=",
          "pledgePriceLt": "Prezzo del Pledge <=",
          "pledgePriceGt": "Prezzo del Pledge >=",
          "priceLt": "Prezzo <=",
          "priceGt": "Prezzo >=",
          "wanted": "Desiderato",
          "hidden": "Nascosto",
          "public": "Pubblico",
          "group": "Gruppo",
          "loaner": "Navi in comodato",
          "bundled": "Snub Craft in bundle",
          "boughtVia": "Acquistato tramite?"
        },
        "models": {
          "name": "Nome",
          "classification": "Classificazione",
          "focus": "Specializzazione",
          "manufacturer": "Produttore",
          "onSale": "In Vendita",
          "ingameOnly": "Solo in gioco",
          "canLandOnPlanets": "Può atterrare sui pianeti",
          "size": "Dimensione",
          "dockSize": "Dimensione dock",
          "price": "Prezzo",
          "pledgePrice": "Prezzo del Pledge",
          "productionStatus": "Stato Della Produzione",
          "lengthLt": "Lunghezza <=",
          "lengthGt": "Lunghezza >=",
          "beamLt": "Raggio <=",
          "beamGt": "Raggio >=",
          "heightLt": "Altezza <=",
          "heightGt": "Altezza >=",
          "pledgePriceLt": "Prezzo del Pledge <=",
          "pledgePriceGt": "Prezzo del Pledge >=",
          "priceLt": "Prezzo <=",
          "priceGt": "Prezzo >=",
          "willItFit": "Ci starà?",
          "withCargo": "Con carico?",
          "scKeyBlank": "Senza SC Key?",
          "positionsNeedCuration": "Posizioni da revisionare?",
          "fleetchartImageBlank": "Senza immagine grafico flotta?",
          "holoBlank": "Senza Holo?",
          "frontViewBlank": "Senza immagine vista frontale?",
          "topViewColoredBlank": "Senza immagine vista dall'alto a colori?",
          "vehicleSize": "Dimensione del veicolo",
          "dimensionsDrifted": "Dimensioni diverse dai file di gioco",
          "dimensionsMeasuredAtNull": "Senza dimensioni misurate?"
        },
        "modelModules": {
          "name": "Nome"
        },
        "manufacturers": {
          "name": "Nome",
          "withModels": "Con modelli",
          "logoBlank": "Senza logo"
        },
        "supporterContributions": {
          "name": "Cerca per nome",
          "recurring": "Ricorrente",
          "anonymous": "Anonimo",
          "startedAtGteq": "Iniziato dal",
          "startedAtLteq": "Iniziato fino al",
          "user": "Account collegato",
          "linked": "Collegamento account",
          "linkedOnly": "Collegato",
          "linkedVia": "Collegato tramite",
          "unlinkedOnly": "Non collegato",
          "sourceStated": "Piattaforma indicata",
          "sourceStatedOnly": "Piattaforma indicata",
          "sourceUnspecifiedOnly": "Piattaforma non indicata",
          "source": "Origine"
        },
        "adminNotifications": {
          "search": "Cerca"
        },
        "images": {
          "model": "Nave"
        },
        "users": {
          "search": "Cerca",
          "username": "Nome utente",
          "email": "E-mail",
          "rsiHandle": "Handle RSI"
        },
        "fleets": {
          "name": "Nome",
          "fid": "FID",
          "memberCountGteq": "Membri minimi",
          "memberCountLteq": "Membri massimi",
          "rsiVerified": "Verificata su RSI",
          "publicFleet": "Pubblica",
          "recruiting": "Recluta",
          "createdOnGteq": "Creata dal",
          "createdOnLteq": "Creata fino al",
          "member": "Membro",
          "members": {
            "search": "Nome utente o soprannome",
            "role": "Ruolo",
            "state": "Stato",
            "acceptedAtGt": "Iscritto dal",
            "acceptedAtLt": "Iscritto fino al",
            "invitedAtGt": "Invitato dal",
            "invitedAtLt": "Invitato fino al",
            "requestedAtGt": "Richiesto dal",
            "requestedAtLt": "Richiesto fino al",
            "declinedAtGt": "Rifiutato dal",
            "declinedAtLt": "Rifiutato fino al",
            "inactiveSince": "Inattivo dal",
            "verified": "Organizzazione RSI",
            "verifiedYes": "Verificato",
            "verifiedNo": "Non verificato",
            "withoutRsiHandle": "Nessun handle RSI",
            "withoutDiscord": "Discord non collegato",
            "withoutSquadron": "Senza squadriglia"
          },
          "inviteUrls": {
            "expiresAfter": "Scade dopo",
            "limit": "Numero massimo di utilizzi"
          },
          "logistics": {
            "search": "Cerca oggetti..."
          }
        },
        "manufacturer": "Produttore",
        "commodities": {
          "description": "Descrizione",
          "traded": "Commerciata da qualche parte",
          "name": "Name",
          "commodityType": "Commodity Type",
          "uexCode": "UEX Code",
          "buyPriceGt": "Prezzo d'acquisto >=",
          "buyPriceLt": "Prezzo d'acquisto <=",
          "sellPriceGt": "Prezzo di vendita >=",
          "sellPriceLt": "Prezzo di vendita <=",
          "storeImageBlank": "Senza immagine negozio?"
        },
        "equipment": {
          "name": "Nome",
          "equipmentType": "Tipo di equipaggiamento",
          "itemType": "Tipo di oggetto",
          "weaponClass": "Classe d'arma",
          "slot": "Slot",
          "size": "Dimensione",
          "grade": "Grado",
          "buyPriceGt": "Prezzo d'acquisto >=",
          "buyPriceLt": "Prezzo d'acquisto <=",
          "sellPriceGt": "Prezzo di vendita >=",
          "sellPriceLt": "Prezzo di vendita <=",
          "storeImageBlank": "Senza immagine negozio?",
          "subType": "Sottotipo"
        },
        "notifications": {
          "search": "Cerca"
        },
        "blueprints": {
          "org": "Distribuito da",
          "scKey": "Chiave di gioco",
          "withKnownSource": "Ha una fonte nota",
          "withCraftable": "Risultato in un catalogo",
          "currentVersion": "Nella build attuale",
          "name": "Cerca progetti",
          "craftableType": "Produce",
          "source": "Fonte",
          "withSource": "Con fonte nota",
          "withoutSource": "Senza fonte nota",
          "alignment": "Allineamento della fonte",
          "material": "Usa materiale",
          "ownedFilter": "Posseduto",
          "owned": "Posseduto",
          "notOwned": "Non posseduto"
        },
        "missions": {
          "location": "Luogo",
          "ship": "La tua nave",
          "name": "Cerca missioni",
          "org": "Offerta da",
          "standing": "Reputazione",
          "rewarding": "Paga",
          "alignment": "Lato della legge",
          "kind": "Tipo",
          "releasedFilter": "Nella release",
          "released": "Nella release",
          "unreleased": "Non nella release"
        },
        "fleetDirectory": {
          "search": "Nome, FID o SID",
          "memberCountGteq": "Membri minimi",
          "activity": "Attività",
          "language": "Lingua",
          "alignment": "Allineamento",
          "commitment": "Impegno",
          "timezone": "Fuso orario",
          "recruiting": "Solo chi recluta",
          "roleplay": "Solo gioco di ruolo"
        }
      },
      "station": {
        "docks": "Moli",
        "location": "Posizione",
        "type": "Tipo",
        "shops": "Negozi",
        "locationPrefix": {
          "default": "su",
          "orbit": "in orbita attorno"
        }
      },
      "tradeRoutes": {
        "intro": "Il miglior viaggio tra due terminali per la tua nave, il tuo budget e quanto recenti vuoi i prezzi. I prezzi provengono da UEX e sono aggiornati ogni ora.",
        "yourRun": "Il tuo viaggio",
        "ship": "Nave",
        "noShip": "Scegli una nave per ordinare per profitto per viaggio",
        "noShipShort": "Nessuna nave",
        "scu": "%{count} SCU",
        "budget": "Budget",
        "budgetPlaceholder": "Facoltativo",
        "buyIn": "Acquista in",
        "anySystem": "Tutti",
        "commodity": "Merce",
        "allCommodities": "Tutte le merci",
        "priceAge": "Prezzi non più vecchi di",
        "priceAges": {
          "day": "24 h",
          "threeDays": "3 giorni",
          "any": "Tutti"
        },
        "bestRun": "Miglior viaggio",
        "buyAt": "Acquista a",
        "sellAt": "Vendi a",
        "pricePerScu": "%{price} aUEC / SCU",
        "distanceValue": "%{count} Gm",
        "jumpTo": "salto verso %{system}",
        "pricesFrom": "Prezzi di %{time}",
        "otherBuyers": {
          "one": "+%{count} altro acquirente",
          "other": "+%{count} altri acquirenti"
        },
        "profitThisRun": "Profitto del viaggio",
        "profitPerScu": "Profitto per SCU",
        "aUecPerScu": "aUEC · %{value} per SCU",
        "load": "Carico",
        "loadOf": "%{load} di %{cargo} SCU",
        "thisShip": "Questa nave",
        "unflyable": {
          "origin": "%{ship} non può atterrare a %{terminal}",
          "destination": "%{ship} non può atterrare a %{terminal}",
          "both": "%{ship} non può atterrare a nessuno dei due terminali"
        },
        "loadLimits": {
          "hold": "Stiva piena",
          "stock": "Limitato dalle scorte",
          "demand": "Limitato dalla domanda",
          "budget": "Limitato dal budget"
        },
        "youSpend": "Spendi",
        "pickShipForRun": "Scegli una nave per vedere il profitto di un viaggio.",
        "moreRuns": "Altri viaggi",
        "runs": "Viaggi",
        "rankBy": "Ordina per",
        "profitPerRun": "Profitto per viaggio",
        "profitPerDistance": "Profitto per Gm",
        "shortest": "Più breve",
        "buySell": "Acquisto → vendita",
        "spend": "Spesa",
        "distance": "Distanza",
        "prices": "Prezzi",
        "profit": "Profitto",
        "to": "verso",
        "everyBuyer": "Tutti gli acquirenti di %{commodity} da %{terminal}",
        "empty": "Nessun viaggio corrisponde. Prova prezzi più vecchi o un altro sistema.",
        "loadExplained": "Il carico usa le dimensioni di cassa accettate da entrambi i terminali e dalla merce, limitato dalle scorte dove acquisti, dalla domanda dove vendi e dal tuo budget.",
        "poweredByUex": "Prezzi forniti da UEX"
      },
      "hardpoints": {
        "prefix": "Prova le configurazioni con",
        "erkul": "Erkul's DPS Calculator",
        "spviewer": "SP Viewer",
        "spviewerTitle": "SC Ships Performances Viewer",
        "metricsCredit": "Metriche basate sulle formule di"
      },
      "scunpacked": {
        "prefix": "Loadouts basato sui Gamefiles powered by",
        "link": "SCunpacked"
      },
      "newVehicle": {
        "nullablePrompt": "Seleziona una Nave"
      },
      "table": {
        "selected": "%{count} selezionati",
        "selectRow": "Seleziona riga",
        "selectAll": "Seleziona tutte le righe"
      },
      "commodityPrice": {
        "item": "ShopCommodity",
        "price": "Prezzo",
        "type": "Tipo",
        "shop": "Negozio"
      },
      "hangarPledgeItems": {
        "flair": "Decorazioni per l'hangar",
        "equipment": "Equipaggiamento FPS",
        "createdOn": "Creato",
        "meltable": "Fondibile",
        "withValue": "Con valore di fusione",
        "paints": "Verniciature",
        "pledge": "Pledge %{id}",
        "meltValue": "Valore di fusione",
        "partOf": "Parte di %{name}",
        "pledgeValue": "Valore del pledge",
        "quantity": "Quantità",
        "search": "Cerca per nome"
      },
      "buybacks": {
        "name": "Pledge riacquistabili",
        "search": "Cerca pledge riacquistabili",
        "kind": "Tipo",
        "kinds": {
          "package": "Pacchetto",
          "ship": "Nave singola",
          "upgrade": "Upgrade",
          "paint": "Verniciatura",
          "addon": "Add-on",
          "other": "Altro"
        },
        "upgraded": "Potenziato",
        "reclaimedOn": "Fuso",
        "notAvailable": "Non disponibile",
        "price": "Prezzo",
        "insurance": "Assicurazione",
        "lifetimeInsurance": "LTI",
        "noInsurance": "Nessuna assicurazione",
        "insuranceMonths": {
          "one": "%{count} mese",
          "other": "%{count} mesi"
        },
        "openOnRsi": "Riacquista su RSI",
        "remove": "Rimuovi",
        "priceRange": "Fascia di prezzo",
        "priceMin": "Prezzo min. (USD)",
        "priceMax": "Prezzo max. (USD)",
        "upgradeFrom": "Upgrade da",
        "upgradeTo": "Upgrade a"
      },
      "buybackSync": {
        "extensionVersion": "Versione installata dell'estensione",
        "detailsProgress": "Lettura dei prezzi di riacquisto",
        "pages": "Pagine",
        "found": "Pledge riacquistabili trovati",
        "added": "Nuovi",
        "removed": "Rimossi",
        "prices": "Prezzi letti",
        "status": {
          "fetching": "Lettura delle pagine di riacquisto",
          "submitting": "Salvataggio",
          "finished": "Completato",
          "unsupported": "Non supportato",
          "failed": "Non riuscito"
        }
      },
      "syncExtension": {
        "warnings": "Avvisi",
        "backgroundProgress": "Sincronizzazione dell'hangar",
        "backgroundFinished": "Sincronizzazione dell'hangar completata",
        "backgroundFailed": "Sincronizzazione dell'hangar non riuscita",
        "backgroundCancelled": "Sincronizzazione dell'hangar annullata",
        "status": {
          "started": "Importazione avviata...",
          "finished": "Importazione completata",
          "failed": "Importazione fallita!",
          "cancelled": "Importazione annullata"
        },
        "processSteps": {
          "fetchHangar": "Recupero dati dall'hangar RSI",
          "submitData": "Invio dati al backend di Fleetyards.net"
        },
        "sessionStatus": "Stato sessione RSI",
        "signedInAs": "Accesso a RSI effettuato come %{handle}",
        "signInToRsi": "Accedi a RSI",
        "checkIdentity": "Verifica sessione RSI",
        "targetGroup": "Gruppo per le navi trovate",
        "addBundledVehicles": "Aggiungi gli snub craft inclusi",
        "addBundledVehiclesHint": "Aggiunge lo snub craft incluso con una nave. Quelli già nel tuo hangar restano.",
        "syncPaints": "Sincronizza verniciature",
        "syncPaintsHint": "Sostituisce le tue verniciature con quelle del tuo hangar RSI. Disattivato lascia invariate quelle salvate.",
        "syncHangarFlair": "Sincronizza decorazioni per l'hangar",
        "syncHangarFlairHint": "Sostituisce le tue decorazioni con quelle del tuo hangar RSI. Disattivato lascia invariate quelle salvate.",
        "syncEquipment": "Sincronizza equipaggiamento FPS",
        "syncEquipmentHint": "Sostituisce il tuo equipaggiamento FPS con quello del tuo hangar RSI. Disattivato lascia invariato quello salvato.",
        "settings": "Impostazioni",
        "unmatchedVehiclesAction": "Navi non presenti nel tuo hangar RSI",
        "unmatchedVehiclesActionHint": "Cosa fare con le navi che hai qui ma che la sincronizzazione non trova nella tua lista di pledge RSI.",
        "unmatchedHangarGroup": "Gruppo in cui archiviarle",
        "unmatchedHangarGroupHint": "Le navi restano invariate, vengono solo raccolte in questo gruppo così puoi sistemarle con calma.",
        "unmatchedVehiclesActions": {
          "wishlist": "Spostale nella lista dei desideri",
          "delete": "Eliminale",
          "keep": "Lasciale invariate",
          "group": "Archiviale in un gruppo"
        },
        "identityStatus": {
          "pending": "Verifica...",
          "notFound": "non trovato",
          "connected": "connesso"
        },
        "platforms": {
          "chrome": "Google Chrome",
          "firefox": "Mozilla Firefox",
          "edge": "Microsoft Edge",
          "opera": "Opera",
          "github": "GitHub"
        },
        "pledgeItems": {
          "pages": "Pagine",
          "all": "Tutti gli oggetti Pledge",
          "ships": "Navi",
          "components": "Moduli",
          "upgrades": "Upgrade",
          "paints": "Verniciature",
          "hangarFlair": "Decorazioni per l'hangar",
          "paintsNotSynced": "Verniciature (non sincronizzate)",
          "hangarFlairNotSynced": "Decorazioni per l'hangar (non sincronizzate)",
          "equipment": "Equipaggiamento FPS",
          "equipmentNotSynced": "Equipaggiamento FPS (non sincronizzato)",
          "extras": "Altri oggetti (smistati tra decorazioni ed equipaggiamento FPS)"
        },
        "importedItems": {
          "importedVehicles": "Navi aggiunte",
          "foundVehicles": "Navi trovate",
          "movedVehiclesToWanted": "Navi spostate nella lista dei desideri",
          "deletedVehicles": "Navi eliminate",
          "groupedVehicles": "Navi archiviate in un gruppo",
          "unchangedVehicles": "Navi lasciate invariate",
          "missingModels": "Navi non trovate",
          "importedComponents": "Componenti aggiunti",
          "foundComponents": "Componenti trovati",
          "missingComponents": "Componenti non trovati",
          "missingComponentVehicles": "Nessuna nave corrispondente trovata per i componenti",
          "importedUpgrades": "Upgrade aggiunti",
          "foundUpgrades": "Upgrade trovati",
          "syncedPaints": "Verniciature sincronizzate",
          "syncedHangarFlair": "Decorazioni per l'hangar sincronizzate",
          "syncedEquipment": "Equipaggiamento FPS sincronizzato",
          "missingUpgrades": "Upgrade non trovati",
          "missingUpgradeVehicles": "Nessuna nave corrispondente trovata per gli upgrade"
        },
        "incomplete": "Alcuni elementi del tuo hangar RSI non sono stati letti, quindi questa volta le navi mancanti sono state lasciate come erano."
      },
      "cargoGridViewer": {
        "capacity": "Capacità",
        "maxContainerSize": "Container max.",
        "packed": "Impacchettato",
        "totalCargo": "Carico totale",
        "didNotFit": "Non entra",
        "enoughShips": "Quattro navi riempiono la griglia.",
        "addShip": "Aggiungi nave",
        "removeShip": "Remove",
        "autoFillShip": "Auto-fill"
      },
      "travelTimes": {
        "quantumDrive": "Motore Quantum",
        "fuelUsage": "Consumo di carburante",
        "travelTime": "Tempo di viaggio",
        "poweredBy": "basato su",
        "rank": "#",
        "size": "Dimensione",
        "grade": "Grado",
        "sizeValue": "S%{size}",
        "intro": "Quanto impiega ogni motore Quantum per il tuo salto — e quanto carburante Quantum consuma.",
        "jumpDistance": "Distanza di salto",
        "distanceHint": "1 Mkm è un milione di chilometri. Attraversare Stanton ne richiede circa 40.",
        "filters": "Filtri",
        "resetFilters": "Reimposta",
        "barLegend": "La barra mostra il tempo rispetto al motore più lento",
        "count": "%{count} motori",
        "countFiltered": "%{count} di %{total} motori",
        "noMatch": "Nessun motore corrisponde a questi filtri.",
        "presets": {
          "moon": "Salto lunare",
          "short": "Salto breve",
          "system": "Attraverso Stanton",
          "far": "Lunga tratta"
        }
      },
      "admin": {
        "importLoaders": {
          "ship_matrix_all": {
            "name": "Tutto",
            "description": "Navi, moduli, livree, navi in prestito e prezzi delle navi, tutto insieme."
          },
          "ship_matrix": {
            "name": "Navi",
            "description": "Tutte le navi con dati e negozio, dalla ship matrix di RSI."
          },
          "modules": {
            "name": "Moduli",
            "description": "Moduli delle navi dal negozio RSI."
          },
          "paints": {
            "name": "Livree",
            "description": "Livree dal negozio RSI."
          },
          "loaners": {
            "name": "Navi in prestito",
            "description": "Quali navi in prestito arrivano con ogni nave, da RSI."
          },
          "uex_vehicle_prices": {
            "name": "Prezzi delle navi",
            "description": "Dove si comprano e noleggiano le navi in gioco, da UEX."
          },
          "sc_data": {
            "name": "Dati di gioco · %{environment}",
            "description": "Tutti i cataloghi dai file di gioco: componenti, equipaggiamento, merci, progetti, missioni e luoghi."
          },
          "sc_data_models": {
            "name": "Navi dai file di gioco",
            "description": "Solo le navi, dalla build predefinita."
          },
          "uex_commodity_prices": {
            "name": "Prezzi delle merci",
            "description": "Prezzi e scorte dei terminali, da UEX."
          },
          "uex_component_prices": {
            "name": "Prezzi dei componenti",
            "description": "Dove si vendono i componenti, da UEX."
          },
          "uex_equipment_prices": {
            "name": "Prezzi dell'equipaggiamento",
            "description": "Dove si vende l'equipaggiamento, da UEX."
          },
          "uex_trade_routes": {
            "name": "Terminali e rotte commerciali",
            "description": "I terminali di UEX e le rotte commerciali tra loro."
          },
          "environments": {
            "live": "Live",
            "ptu": "PTU"
          }
        },
        "locations": {
          "parent": "Superiore",
          "system": "Sistema",
          "scKey": "Chiave del gioco",
          "scRefs": "Riferimenti del gioco",
          "slug": "Slug",
          "gameType": "Tipo del gioco",
          "build": "Build",
          "children": "Luoghi all'interno",
          "missions": "Missioni collegate",
          "missionTemplates": "Modelli di missione",
          "shownWithParentOnly": "Visibile solo con il superiore",
          "yes": "Sì",
          "no": "No",
          "unavailable": "non disponibile",
          "appearance": "Aspetto",
          "image": "Immagine",
          "color": "Colore",
          "appearanceHint": "Il colore riempie il cerchio del pianeta o della luna, ombreggiato come una sfera illuminata. Se lasciato vuoto, viene preso dall’immagine al caricamento.",
          "headerImageHint": "L’immagine viene mostrata come intestazione nella pagina del luogo.",
          "shops": "Negozi",
          "shopImageHint": "L’immagine viene mostrata come intestazione nella pagina del negozio.",
          "sunHint": "Il colore tinge il bagliore della stella."
        },
        "blueprints": {
          "status": {
            "sourceKnown": "Fonte nota",
            "outputResolved": "Risultato in un catalogo"
          },
          "columns": {
            "source": "Fonte",
            "output": "Risultato",
            "build": "Build",
            "created": "Creato il",
            "slot": "Slot",
            "material": "Materiale",
            "type": "Tipo",
            "quantity": "Quantità",
            "minQuality": "Qualità min.",
            "stat": "Statistica",
            "change": "Variazione",
            "base": "Base",
            "ramp": "Progressione",
            "kind": "Tipo",
            "org": "Org",
            "mission": "Missione",
            "standing": "Reputazione",
            "pool": "Pool"
          },
          "makes": "Produce",
          "noOutput": "In nessun catalogo",
          "slug": "Slug",
          "scKey": "Chiave di gioco",
          "scRef": "Riferimento di gioco",
          "build": "Build",
          "state": "Stato",
          "states": {
            "current": "Attuale",
            "retired": "Ritirato"
          },
          "createdAt": "Creato il",
          "updatedAt": "Aggiornato il"
        },
        "missions": {
          "unnamed": "Mai nominata dal gioco",
          "slug": "Slug",
          "scKey": "Chiave di gioco",
          "scRef": "Rif di gioco",
          "generator": "Generatore",
          "debugName": "Nome di debug",
          "build": "Build",
          "difficultyAxes": "Difficoltà (abilità / carico / rischio / conoscenza)",
          "state": "Stato",
          "states": {
            "retired": "Ritirata",
            "released": "Nella release",
            "unreleased": "Non nella release"
          },
          "columns": {
            "released": "Nella release",
            "generator": "Generatore",
            "build": "Build",
            "rewardKind": "Tipo",
            "amount": "Importo",
            "rewardDetail": "Dettaglio"
          },
          "filters": {
            "debugName": "Nome di debug",
            "named": "Nominata",
            "unnamed": "Mai nominata",
            "namedFilter": "Denominazione",
            "currentBuild": "Solo build corrente",
            "anyBuild": "Qualsiasi build",
            "build": "Build"
          }
        },
        "dashboard": {
          "quickStats": {
            "onlineUsers": "Utenti online"
          }
        },
        "supporterContributions": {
          "source": {
            "patreon": "Patreon",
            "kofi": "Ko-fi",
            "buymeacoffee": "Buy me a coffee",
            "paypal": "PayPal",
            "other": "Altro"
          },
          "linkedVia": {
            "patreon_account": "Account Patreon",
            "claim_key": "Token sostenitore",
            "payer_email": "Email del pagante",
            "manual": "Impostato da un admin"
          }
        },
        "announcements": {
          "columns": {
            "title": "Titolo",
            "status": "Stato",
            "deliveries": "Canali",
            "recipients": "Destinatari",
            "publishedAt": "Inviato"
          },
          "statuses": {
            "draft": "Bozza",
            "scheduled": "Pianificato",
            "publishing": "In invio",
            "published": "Inviato",
            "failed": "Fallito"
          },
          "channels": {
            "in_app": "In-app",
            "discord": "Discord",
            "bluesky": "Bluesky"
          },
          "deliveryStatuses": {
            "pending": "In attesa",
            "succeeded": "Inviato",
            "skipped": "Saltato",
            "failed": "Fallito"
          },
          "lastTested": "Ultimo test %{time}",
          "noChannel": "Scegli almeno un canale.",
          "notifyUsersInfo": "E-mail solo se attivata.",
          "discordPartsInfo": "Vuoto: diviso automaticamente.",
          "socialPartsInfo": "Vuoto: un post tagliato. Da due: un thread.",
          "recipientsCount": "%{count} destinatari",
          "partPosition": "%{position} di %{total}",
          "deliverySummary": "%{sent}/%{total} inviati",
          "deliveryFailedCount": "%{count} non riusciti",
          "deliveryPendingCount": "%{count} in attesa",
          "deliverySkippedCount": "%{count} saltati",
          "attempts": "%{count} tentativi",
          "content": "Contenuto",
          "manualPostsInfo": "Il testo che riceve Bluesky, da pubblicare a mano su X o altrove.",
          "engagement": {
            "likes": "Mi piace",
            "reposts": "Repost",
            "replies": "Risposte",
            "quotes": "Citazioni",
            "noReactions": "Ancora nessuna reazione.",
            "fetchedAt": "Aggiornato %{time}",
            "notFetched": "I numeri arrivano entro un'ora.",
            "untracked": "Pubblicato prima che le reazioni venissero registrate."
          }
        },
        "resourceAccess": {
          "title": "Accesso alle risorse",
          "groups": {
            "ship_data": "Dati delle navi",
            "community": "Community",
            "system": "Sistema"
          },
          "privileges": {
            "locations": "Luoghi",
            "blueprints": "Progetti",
            "models": "Modelli",
            "model_modules": "Moduli dei modelli",
            "components": "Componenti",
            "manufacturers": "Produttori",
            "vehicles": "Veicoli",
            "images": "Immagini",
            "fleets": "Flotte",
            "users": "Utenti",
            "supporters": "Sostenitori",
            "admins": "Admin",
            "announcements": "Annunci",
            "oauth_applications": "Applicazioni OAuth",
            "maintenance": "Manutenzione",
            "imports": "Importazioni",
            "features": "Funzionalità",
            "workers": "Worker",
            "pghero": "PgHero",
            "rsi-api-status": "Stato API RSI",
            "stats": "Statistiche"
          }
        },
        "versions": {
          "blank": "vuoto",
          "revertQuestion": "Ripristinare?",
          "sources": {
            "custom": "Admin",
            "rsi_loader": "Ship Matrix",
            "sc_data_loader": "File di gioco",
            "sc_loader": "File di gioco",
            "uex_price_sync": "Sincronizzazione prezzi UEX",
            "unknown": "Sconosciuto"
          }
        },
        "models": {
          "unlisted": "Senza modello"
        }
      },
      "hangarTable": {
        "extraColumns": "Colonne",
        "columns": {
          "storeImage": "Immagine",
          "storeImageWide": "Immagine larga",
          "angledView": "Immagine 3D",
          "angledViewWide": "Immagine 3D larga",
          "modelManufacturerName": "Produttore",
          "modelLength": "Lunghezza",
          "modelBeam": "Larghezza",
          "modelHeight": "Altezza",
          "modelMass": "Massa",
          "modelCargo": "Carico",
          "modelCrew": "Equipaggio",
          "modelScmSpeed": "SCM Speed",
          "modelMaxSpeed": "Velocità max.",
          "modelGroundMaxSpeed": "Velocità a terra",
          "modelFocus": "Specializzazione",
          "modelProductionStatus": "Stato di produzione",
          "modelPrice": "Prezzo",
          "modelPledgePrice": "Prezzo Pledge"
        }
      },
      "fleetTable": {
        "extraColumns": "Colonne",
        "columns": {
          "storeImage": "Immagine",
          "storeImageWide": "Immagine larga",
          "angledView": "Immagine 3D",
          "angledViewWide": "Immagine 3D larga",
          "modelManufacturerName": "Produttore",
          "modelLength": "Lunghezza",
          "modelBeam": "Larghezza",
          "modelHeight": "Altezza",
          "modelMass": "Massa",
          "modelCargo": "Carico",
          "modelCrew": "Equipaggio",
          "modelScmSpeed": "SCM Speed",
          "modelMaxSpeed": "Velocità max.",
          "modelGroundMaxSpeed": "Velocità a terra",
          "modelProductionStatus": "Stato di produzione",
          "modelPrice": "Prezzo",
          "modelPledgePrice": "Prezzo Pledge",
          "owner": "Proprietario",
          "vehiclesCount": "Quantità"
        }
      },
      "logistics": {
        "inventoryCount": "inventories",
        "pending": "pending",
        "entriesCount": "entries",
        "managedBy": "Managed by",
        "itemName": "Name",
        "category": "Category",
        "component": "Component",
        "componentCategory": "Component Type",
        "commodity": "Commodity",
        "commodityType": "Commodity Type",
        "equipment": "Equipment",
        "equipmentItemType": "Equipment Type",
        "quantity": "Quantity",
        "unit": "Unit",
        "notes": "Notes",
        "status": "Status",
        "requested": "Requested",
        "description": "Description",
        "priority": "Priority",
        "requestedBy": "Requested by",
        "states": {
          "draft": "Draft",
          "submitted": "Submitted",
          "rejected": "Rejected",
          "cancelled": "Cancelled"
        },
        "requestTypes": {
          "general": "General"
        },
        "priorities": {
          "standard": "Standard",
          "critical": "Critical"
        },
        "searchItems": "Search items...",
        "quality": "Quality (0-1000)",
        "qualityMin": "Quality >=",
        "qualityMax": "Quality <=",
        "existingItem": "Select existing item",
        "inventoryName": "Inventory Name",
        "visibility": "Visibility",
        "visibilities": {
          "members_only": "All Members",
          "officers_only": "Officers Only",
          "squadron_only": "Solo squadrone"
        },
        "inventory": "Inventory",
        "notesPlaceholder": "Add notes...",
        "entryType": "Type",
        "entryTypes": {
          "deposit": "Deposit",
          "withdrawal": "Withdrawal"
        },
        "stockView": "Current Stock",
        "logView": "Transaction Log",
        "addedBy": "Logged by",
        "member": "Member",
        "selectItem": "Select item",
        "currentStock": "Available",
        "location": "Location",
        "image": "Image",
        "categories": {
          "commodity": "Commodity",
          "component": "Component",
          "weapon": "Weapon",
          "equipment": "Equipment",
          "ammunition": "Attachments & Ammunition",
          "consumable": "Consumable",
          "other": "Other"
        },
        "units": {
          "scu": "SCU",
          "units": "Units"
        },
        "csvImportHelp": "Upload a CSV file with columns: name, category, quantity, unit, notes. Download the template for the correct format.",
        "imported": "items imported",
        "importErrors": "errors",
        "inStock": "In stock",
        "entries": "Entries",
        "lastEntry": "Last entry",
        "history": "History",
        "linkedItem": "Linked item",
        "itemUnavailable": "Not in current patch",
        "itemUnavailableHint": "The current game build no longer ships this item. Entries keep it, but it cannot be picked for new ones.",
        "qualityRange": "Quality",
        "stockItem": "Stock Item",
        "overCapacity": "oltre la capacità di carico",
        "cargoGrid": "Griglia di carico",
        "shipInventory": "Inventario della nave",
        "remaining": "Rimanente",
        "unmeasured": "%{count} non ancora misurati",
        "transferTarget": "Destinatario",
        "transferNote": "Nota",
        "noStock": "Niente da spostare",
        "overStock": "Più di quanto contenga questa posizione",
        "incoming": "In arrivo",
        "outgoing": "In uscita",
        "transferStates": {
          "pending": "In attesa",
          "completed": "Consegnato",
          "declined": "Rifiutato",
          "cancelled": "Annullato",
          "expired": "Scaduto"
        },
        "acceptInto": "Accetta in",
        "reportReason": "Motivo",
        "reportReasons": {
          "spam": "Spam",
          "harassment": "Molestie",
          "scam": "Truffa",
          "other": "Altro"
        },
        "transferToFleet": "%{fleet} (flotta)",
        "sender": "Da",
        "recipient": "A",
        "contents": "Contenuto",
        "state": "Stato",
        "sentAt": "Inviato",
        "transferKinds": {
          "inventory": "I miei inventari",
          "fleet": "Una flotta",
          "user": "Una persona",
          "mine": "I miei inventari",
          "fleetInventories": "Questa flotta",
          "contract": "Un contratto su cui lavoro"
        },
        "transferTargetKind": "Invia a",
        "contractDeliveryTarget": "%{contract} (%{fleet}): %{destination}",
        "transferFromFleet": "Dalla flotta",
        "noTransferTargets": "Nessuna destinazione qui",
        "recordedAt": "Registrato",
        "origin": "Da / A",
        "inTransitAmount": "%{amount} in transito",
        "inTransitHint": "Inviato con un trasferimento a cui nessuno ha risposto. Già fuori dai totali.",
        "transferFromFriends": "I miei amici",
        "towardsContract": "Per un contratto",
        "noContract": "Nessun contratto",
        "forContract": "per",
        "openInCatalogue": "Apri nel catalogo"
      },
      "hangarInventories": "Inventories",
      "adminNotifications": {
        "inbox": "In arrivo",
        "archive": "Archivio",
        "unreadOnly": "Solo non lette",
        "status": "Stato",
        "severity": "Gravità",
        "type": "Tipo",
        "selectPrompt": "Seleziona una notifica per leggerla",
        "noBody": "Questa notifica non contiene ulteriori dettagli.",
        "lastSeen": "Vista l'ultima volta",
        "expires": "Scade",
        "severities": {
          "info": "Info",
          "warning": "Avviso",
          "error": "Errore"
        },
        "types": {
          "paints_import": "Importazione verniciature",
          "modules_import": "Importazione moduli",
          "loaner_sync": "Sincronizzazione comodati",
          "uex_prices_import": "Sincronizzazione prezzi UEX",
          "uex_commodity_prices_import": "Sincronizzazione commodity UEX",
          "uex_component_prices_import": "Sincronizzazione componenti UEX",
          "uex_equipment_prices_import": "Sincronizzazione equipaggiamento UEX",
          "uex_trade_routes_sync": "Sincronizzazione rotte commerciali UEX",
          "new_supporter": "Nuovo sostenitore",
          "rsi_api_blocked": "API RSI bloccata",
          "rsi_api_unblocked": "API RSI ripristinata",
          "rsi_markup_changed": "Pagina RSI modificata",
          "weekly_stats": "Report settimanale",
          "ship_matrix_import": "Importazione Ship Matrix",
          "sc_data_import": "Importazione sc_data",
          "sc_data_unlisted_models": "Navi non elencate",
          "import_run": "Importazione",
          "oauth_application_review": "Revisione applicazione OAuth",
          "inventory_transfer_reports": "Trasferimenti di inventario segnalati"
        }
      },
      "optional": "facoltativo",
      "notificationActions": {
        "open": "Apri",
        "openHangar": "Apri l'hangar",
        "openModel": "Mostra la nave",
        "openInvite": "Vedi l'invito",
        "reviewRequest": "Esamina la richiesta",
        "openMembers": "Mostra i membri",
        "openFleet": "Apri la flotta",
        "openInventory": "Apri l'inventario",
        "openEvent": "Apri l'evento",
        "openRoster": "Mostra le iscrizioni",
        "addToCalendar": "Aggiungi al calendario",
        "openStore": "Pledge store",
        "accept": "Accetta",
        "decline": "Rifiuta",
        "signUp": "Iscriviti",
        "withdraw": "Ritirati",
        "syncAgain": "Sincronizza di nuovo",
        "markAsBought": "Segna come acquistata",
        "unavailable": "Non è più disponibile.",
        "openTransfers": "Apri trasferimenti",
        "openFriends": "Apri gli amici",
        "openAllies": "Apri gli alleati",
        "openTour": "Apri spedizione",
        "openSquadron": "Apri squadrone",
        "openContract": "Apri contratto",
        "openPayouts": "Apri i pagamenti"
      },
      "notificationTypes": {
        "channels": {
          "app": "App",
          "mail": "Email",
          "push": "Push",
          "discord": "Discord"
        },
        "groups": {
          "account": "Account e hangar",
          "announcements": "Annunci",
          "fleetMembership": "Iscrizione alla flotta",
          "fleetEvents": "Eventi della flotta",
          "logistics": "Logistica",
          "relationships": "Amici e alleati",
          "tours": "Spedizioni",
          "fleetContracts": "Contratti della flotta"
        },
        "announcement": "Annuncio",
        "hangar_sync_finished": "Sincronizzazione hangar completata",
        "hangar_sync_failed": "Sincronizzazione hangar fallita",
        "model_on_sale": "Modello in vendita",
        "new_model": "Nuovo modello rilasciato",
        "fleet_invite": "Invito a una flotta ricevuto",
        "fleet_member_requested": "Richiesta di iscrizione",
        "fleet_member_accepted": "Iscrizione accettata",
        "fleet_request_accepted": "Richiesta di partecipazione accettata",
        "fleet_joined_by_discord_role": "Ingresso tramite ruolo Discord",
        "fleet_inventory_item_added": "Oggetto aggiunto all'inventario della flotta",
        "fleet_event_published": "Evento pubblicato",
        "fleet_event_locked": "Iscrizioni all'evento bloccate",
        "fleet_event_starting_soon": "Evento in partenza",
        "fleet_event_started": "Evento avviato",
        "fleet_event_completed": "Evento completato",
        "fleet_event_cancelled": "Evento annullato",
        "fleet_event_signup_added": "Nuova iscrizione",
        "fleet_event_signup_withdrawn": "Iscrizione ritirata",
        "fleet_event_signup_confirmed": "Iscrizione confermata",
        "fleet_event_signup_assigned": "Assegnato a uno slot",
        "fleet_event_signup_kicked": "Rimosso da uno slot",
        "allInGroup": "Tutto in questo gruppo",
        "inventory_transfer_received": "Trasferimento ricevuto",
        "inventory_transfer_resolved": "Trasferimento gestito",
        "friend_request_received": "Richiesta di amicizia ricevuta",
        "friend_request_accepted": "Richiesta di amicizia accettata",
        "fleet_ally_request_received": "Richiesta di alleanza ricevuta",
        "fleet_ally_request_accepted": "Richiesta di alleanza accettata",
        "tour_join_request_received": "Richiesta di partecipazione ricevuta",
        "tour_join_request_accepted": "Richiesta di partecipazione accettata",
        "fleet_squadron_request_received": "Richiesta di adesione allo squadrone",
        "fleet_squadron_request_accepted": "Richiesta di squadrone accettata",
        "fleet_contract_published": "Contratto pubblicato",
        "fleet_announcement_posted": "Annuncio pubblicato",
        "fleet_contract_claimed": "Contratto preso in carico",
        "fleet_contract_crew_requested": "Qualcuno vuole unirsi a un contratto",
        "fleet_contract_crew_answered": "Richiesta di equipaggio gestita",
        "fleet_subscription_started": "Funzioni di flotta attivate",
        "fleet_subscription_ended": "Funzioni di flotta perse",
        "fleet_fid_claim_opened": "ID flotta rivendicato",
        "fleet_fid_claim_completed": "ID flotta trasferito",
        "fleet_fid_claim_cancelled": "Rivendicazione dell’ID flotta terminata",
        "fleet_rsi_verification_lost": "Verifica della flotta persa",
        "rsi_handle_verification_lost": "Verifica dell’handle RSI persa",
        "fleet_contract_fulfilled": "Contratto completato",
        "fleet_contract_settled": "Contratto pagato",
        "payout_ledger_settled": "Pagamenti definiti",
        "payout_entry_pending_review": "Spesa in attesa di verifica",
        "payout_entry_declined": "Spesa rifiutata",
        "fleet_verification_requested": "Verifica richiesta dalla tua flotta"
      },
      "fleets": {
        "missions": {
          "untitled": "Missione senza titolo",
          "title": "Titolo",
          "description": "Descrizione",
          "team": "Team",
          "teams": "Team",
          "ship": "Nave",
          "ships": "Navi",
          "slot": "Slot",
          "slots": "Slot",
          "noMissions": "Ancora nessuna missione.",
          "noTeams": "Ancora nessun team aggiunto.",
          "noShips": "Ancora nessuna nave aggiunta.",
          "noSlots": "Ancora nessuno slot aggiunto.",
          "archivedTab": "Archiviate",
          "activeTab": "Attive",
          "archived": "Archiviata",
          "modelSpecific": "Nave specifica",
          "modelList": "Una di queste",
          "modelListHint": "Il posto accetta una qualsiasi delle navi che scegli.",
          "allowedShips": "Navi compatibili",
          "anyOf": "Una di",
          "filterRange": "Intervallo del filtro",
          "classification": "Classificazione",
          "focus": "Specializzazione",
          "minSize": "Dimensione min.",
          "maxSize": "Dimensione max.",
          "minCrew": "Equipaggio min.",
          "minCrewOverride": "Sovrascrivi",
          "minCrewOverrideLabel": "Sovrascrittura equipaggio min.",
          "minCrewOverrideHint": "Lascia vuoto per usare l'equipaggio della nave.",
          "minCargo": "Carico min. (SCU)",
          "createdBy": "Creata da",
          "seats": "Posti",
          "category": "Categoria",
          "coverImage": "Immagine di copertina",
          "scenario": "Scenario",
          "categories": {
            "other": "Altro",
            "ship_combat": "Combattimento spaziale",
            "ground_combat": "Combattimento terrestre",
            "combined_combat": "Combattimento combinato",
            "mining": "Estrazione mineraria",
            "salvage": "Recupero",
            "cargo_hauling": "Trasporto merci",
            "exploration": "Esplorazione"
          }
        },
        "events": {
          "untitled": "Evento senza titolo",
          "title": "Titolo",
          "description": "Descrizione",
          "briefing": "Briefing",
          "startsAt": "Inizia il",
          "endsAt": "Termina il",
          "timezone": "Fuso orario",
          "location": "Luogo dell'evento",
          "meetupLocation": "Luogo di ritrovo",
          "visibility": "Visibilità",
          "maxAttendees": "Partecipanti max.",
          "autoLockEnabled": "Blocca automaticamente le iscrizioni",
          "autoLockMinutesBefore": "Minuti prima dell'inizio per il blocco",
          "recurring": "Si ripete",
          "recurringHint": "Genera automaticamente questo evento a intervalli regolari. I membri si iscrivono a ogni singola occorrenza.",
          "recurringSummary": "Si ripete %{interval}",
          "recurringUntil": "Si ripete %{interval} fino al %{date}",
          "recurringForCount": "Si ripete %{interval} (%{count} occorrenze)",
          "viewSeries": "Vedi la serie",
          "recurrenceInterval": "Ripeti ogni",
          "recurrenceEnd": "Termina",
          "recurrenceEndNever": "Mai",
          "recurrenceEndOn": "In data",
          "recurrenceEndAfter": "Dopo",
          "recurrenceEndOccurrences": "occorrenze",
          "recurrenceUnit": {
            "daily": "giorni",
            "weekly": "settimane",
            "monthly": "mesi"
          },
          "recurrenceWeekdays": "Nei giorni",
          "recurrenceWeekdaysHint": "Il giorno in cui inizia l'evento è sempre incluso.",
          "recurrence": {
            "daily": "ogni giorno",
            "weekly": "ogni settimana",
            "monthly": "ogni mese",
            "everyN": {
              "daily": "ogni %{count} giorni",
              "weekly": "ogni %{count} settimane",
              "monthly": "ogni %{count} mesi"
            },
            "onDays": "%{interval} (%{days})"
          },
          "occurrencesSection": "Prossime occorrenze",
          "skipOccurrence": "Salta questa occorrenza",
          "overrideOccurrence": "Sovrascrivi l'occorrenza del %{date}",
          "overrideOccurrenceShort": "Modifica solo questa",
          "overrideOccurrenceHint": "Sovrascrivi i campi per questa singola occorrenza. Lascia vuoto per ereditarli dall'evento ricorrente.",
          "endSeriesHere": "Interrompi da qui in avanti",
          "splitSeriesHere": "Modifica questa e le successive",
          "splitSeriesConfirm": "Continuare la serie da questa data come nuovo evento? Le iscrizioni per questa data e le successive vengono spostate, e il nuovo evento si apre per la modifica.",
          "excludedBadge": "Saltata",
          "noUpcomingOccurrences": "Nessuna occorrenza in programma nelle prossime 12 settimane.",
          "endSeriesConfirm": "Vuoi interrompere la ricorrenza dopo questa data? Le occorrenze future non verranno generate.",
          "skipOccurrenceSuccess": "Occorrenza saltata.",
          "unskipOccurrence": "Ripristina questa occorrenza",
          "unskipOccurrenceSuccess": "Occorrenza ripristinata.",
          "endSeriesSuccess": "Serie terminata a partire da questa data.",
          "cancelledReason": "Motivo dell'annullamento",
          "createdBy": "Creato da",
          "signups": "Iscrizioni",
          "signupsCount": "%{count} iscrizioni",
          "youAreHere": "Sei qui",
          "attendance": "Partecipazione",
          "signupsLockedHint": "Le iscrizioni a questo evento sono bloccate.",
          "alreadySignedUpHint": "Sei già iscritto a un altro slot. Ritirati prima di cambiare.",
          "slotTakenHint": "Questo slot è già occupato.",
          "currentSlot": "Slot attuale",
          "currentSlotHint": "Questo è lo slot in cui si trova attualmente l'iscrizione.",
          "takenBy": "Occupato da %{username}",
          "slotPickerHint": "Scegli uno slot per questa iscrizione. Gli slot già occupati o non disponibili sono disattivati.",
          "signupCtaHint": "Iscriviti all'evento — puoi scegliere subito uno slot specifico oppure farti assegnare più tardi da un admin.",
          "noSlotYet": "Ancora nessuno slot",
          "signupApproval": "Approvazione delle iscrizioni",
          "signupStatuses": {
            "confirmed": "Confermata",
            "tentative": "Non definitiva",
            "interested": "Interessato",
            "pending": "In attesa di approvazione",
            "withdrawn": "Ritirata"
          },
          "signupApprovals": {
            "direct": "Diretta",
            "confirmation_required": "Richiede conferma"
          },
          "unassignedSignupsHint": "Questi membri si sono iscritti all'evento ma non hanno ancora uno slot. Assegnali qui sotto oppure rimuovi l'iscrizione.",
          "taken": "Occupato",
          "grantedRoles": "Ruoli assegnati",
          "noEventAdminsYet": "Ancora nessun admin o moderatore aggiuntivo.",
          "creator": "Creatore dell'evento",
          "eventTeamHint": "Assegna ad altri membri i diritti di admin o moderatore per questo evento. Gli admin possono modificarlo, i moderatori possono gestire le iscrizioni.",
          "eventRole": "Ruolo",
          "eventRoles": {
            "admin": "Admin",
            "moderator": "Moderatore"
          },
          "memberPicker": "Membro",
          "spawnedEvents": "Eventi generati",
          "fromMission": "Dalla missione",
          "pickTemplate": "Scegli un modello",
          "pickTemplateHint": "Puoi partire da una missione — dettagli, team, navi e slot vengono copiati nell'evento, che resta collegato ad essa.",
          "noTemplate": "Nessun modello",
          "noTemplateHint": "Crea l'evento da zero.",
          "pickTemplateLoadFailed": "Impossibile caricare le missioni della flotta.",
          "pickTemplatePageFailed": "Impossibile caricare le missioni successive.",
          "pickTemplateSearch": "Cerca missioni",
          "pickTemplateNonePublished": "Nessuna missione attiva della flotta è ancora pubblicata.",
          "pickTemplateNoneActive": "La flotta non ha missioni attive.",
          "pickTemplateNoMatch": "Nessuna missione pubblicata corrisponde alla ricerca.",
          "changeTemplate": "Cambia modello",
          "clearTemplate": "Rimuovi il modello",
          "myVehicle": "Il mio veicolo",
          "selectVehicle": "Seleziona un veicolo (facoltativo)",
          "vehicleMismatchHint": "Il veicolo selezionato non soddisfa i requisiti di questo slot.",
          "noFittingInHangar": "Niente nel tuo hangar è adatto a questo slot. Puoi comunque iscriverti lasciando vuoto il veicolo.",
          "vehicleFitsHint": "Porta un veicolo adatto a questa nave.",
          "notes": "Note",
          "upcomingTab": "In programma",
          "pastTab": "Passati",
          "archivedTab": "Archiviati",
          "listTab": "Elenco",
          "calendarTab": "Calendario",
          "subscribeHint": "Copia negli appunti l'URL del feed del calendario così puoi incollarlo nella tua app calendario.",
          "visibilities": {
            "members": "Membri",
            "officers": "Ufficiali",
            "fleet": "Pubblico",
            "squadron": "Solo squadrone"
          },
          "statuses": {
            "draft": "Bozza",
            "open": "Iscrizioni aperte",
            "locked": "Iscrizioni bloccate",
            "active": "In corso",
            "completed": "Completato",
            "cancelled": "Annullato",
            "past": "Passato"
          },
          "tabs": {
            "basic": "Informazioni di base",
            "description": "Descrizione e copertina",
            "teams": "Team e navi",
            "overview": "Panoramica",
            "settings": "Impostazioni"
          },
          "calendar": {
            "month": "Mese",
            "week": "Settimana",
            "weekTitle": "Settimana del %{date}"
          },
          "repeats": "Ricorrente"
        },
        "contracts": {
          "tabs": {
            "details": "Dettagli",
            "delivery": "Consegna",
            "crew": "Equipaggio e premio",
            "goods": "Merci"
          },
          "title": "Titolo",
          "description": "Descrizione",
          "reward": "Ricompensa",
          "deadline": "Scadenza",
          "crewLimit": "Limite equipaggio",
          "visibility": "Visibilità",
          "visibilities": {
            "members_only": "Tutti i membri",
            "squadron_only": "Solo squadrone"
          },
          "reimburseExpenses": "Rimborsa le spese",
          "from": "Ritira da",
          "to": "Consegna a",
          "toHint": "Le consegne in uno dei tuoi inventari vengono inviate a te, e sei tu ad accettarle.",
          "toAuthorHint": "Le consegne vanno a %{username}, che le accetta.",
          "myHangarInventory": "%{name} (il mio hangar)",
          "authorHangarInventory": "%{name} (hangar di %{username})",
          "destinationRemoved": "Non più disponibile",
          "lead": "Responsabile",
          "pendingCrew": "In attesa",
          "minQuality": "qualità min. %{value}",
          "pickedUp": "%{quantity} ritirato",
          "itemName": "Articolo",
          "itemCategory": "Categoria",
          "itemUnit": "Unità",
          "itemQuantity": "Quantità",
          "kind": {
            "label": "Tipo",
            "transport": "Trasporto",
            "procurement": "Approvvigionamento",
            "crafting": "Fabbricazione"
          },
          "state": {
            "draft": "Bozza",
            "open": "Aperto",
            "in_progress": "In corso",
            "fulfilled": "Completato",
            "cancelled": "Annullato",
            "expired": "Scaduto",
            "settled": "Liquidato"
          },
          "itemTypes": {
            "Commodity": "Merce",
            "Component": "Componente",
            "Equipment": "Equipaggiamento"
          },
          "qualityMatch": "Corrispondenza",
          "exactQuality": "esattamente %{value}",
          "qualityMatches": {
            "at_least": "Almeno",
            "exact": "Esattamente"
          },
          "itemQuality": "Qualità",
          "titleHint": "Facoltativo — senza titolo il contratto prende il nome dalle merci richieste",
          "postedBy": "Pubblicato da",
          "claimedBy": "preso da",
          "delivered": "Consegnato",
          "deliveredOf": "%{delivered} / %{requested} %{unit}",
          "views": {
            "open": "Aperti",
            "closed": "Chiusi",
            "mine": "I miei",
            "completed": "Completati"
          }
        }
      },
      "commodity": {
        "name": "Nome",
        "buyPrice": "Acquisto",
        "sellPrice": "Vendita",
        "retired": "Non più presente nella build attuale",
        "containerSizes": "Dimensioni container (SCU)",
        "pieceVolume": "Volume per pezzo (SCU)",
        "consumable": "Consumabile",
        "refinesInto": "Si raffina in",
        "refinedFrom": "Raffinato da",
        "availability": {
          "retired": "I prezzi sono tracciati per la build su cui si trova il catalogo, e questa merce non è presente.",
          "craftedOnly": "Nessun terminale la commercia — è un materiale di fabbricazione.",
          "none": "Nessun terminale a noi noto compra o vende questa merce."
        },
        "chart": {
          "buyHighest": "Acquisto, massimo",
          "buyAverage": "Acquisto, medio",
          "buyLowest": "Acquisto, minimo",
          "sellHighest": "Vendita, massima",
          "sellAverage": "Vendita, media",
          "sellLowest": "Vendita, minima"
        },
        "types": {
          "agricultural_supply": "Forniture agricole",
          "alloy": "Leghe",
          "consumer_goods": "Beni di consumo",
          "drink": "Bevande",
          "food": "Cibo",
          "gas": "Gas",
          "hpmc": "HPMC",
          "manmade": "Artificiale",
          "medical_supply": "Forniture mediche",
          "metal": "Metalli",
          "military_supply": "Forniture militari",
          "mineral": "Minerali",
          "natural": "Naturale",
          "nonmetals": "Non metalli",
          "plasma_fuel": "Carburante al plasma",
          "processed_goods": "Beni lavorati",
          "quantum_fuel": "Carburante quantico",
          "rmc": "RMC",
          "scrap": "Rottami",
          "vice": "Vizio",
          "waste": "Rifiuti"
        },
        "commodityType": "Commodity Type",
        "uexId": "UEX ID",
        "uexCode": "UEX Code",
        "scKey": "SC Key",
        "scRef": "SC Ref",
        "storeImage": "Store Image"
      },
      "equipment": {
        "equipmentType": "Tipo di equipaggiamento",
        "itemType": "Tipo di oggetto",
        "subType": "Sottotipo",
        "weaponClass": "Classe d'arma",
        "slot": "Slot",
        "size": "Dimensione",
        "grade": "Grado",
        "hidden": "Hidden?",
        "scKey": "SC Key",
        "scRef": "SC Ref",
        "storeImage": "Store Image",
        "name": "Nome",
        "manufacturer": "Produttore",
        "retired": "Non più presente nella build attuale",
        "noMetrics": "Nessun dato registrato per questo oggetto.",
        "availability": {
          "retired": "I prezzi sono rilevati per la build su cui si trova il catalogo, e questo oggetto non ne fa parte.",
          "craftedOnly": "Nessun terminale lo vende: si produce con la ricetta qui sotto.",
          "none": "Nessun terminale lo compra o lo vende."
        },
        "stats": {
          "damageReduction": "Riduzione danni",
          "temperatureRating": "Intervallo di temperatura",
          "radiationProtection": "Protezione dalle radiazioni",
          "radiationScrubRate": "Velocità di smaltimento radiazioni",
          "gForceTolerance": "Tolleranza alla forza G",
          "carryingCapacity": "Capacità di carico",
          "magazineSize": "Capacità caricatore",
          "rateOfFire": "Cadenza di tiro",
          "range": "Portata effettiva",
          "weaponClass": "Classe d'arma",
          "coreCompatibility": "Compatibilità del nucleo",
          "backpackCompatibility": "Compatibilità zaino",
          "volume": "Volume"
        },
        "sorts": {
          "damageReduction": "Riduzione danni",
          "radiationProtection": "Protezione dalle radiazioni",
          "gForceTolerance": "Tolleranza alla forza G",
          "rateOfFire": "Cadenza di tiro",
          "range": "Portata",
          "storage": "Capacità",
          "volume": "Volume"
        }
      },
      "notifications": {
        "inbox": "In arrivo",
        "archive": "Archivio",
        "unreadOnly": "Solo non lette",
        "status": "Stato",
        "type": "Tipo",
        "selectPrompt": "Seleziona una notifica per leggerla",
        "noBody": "Questa notifica non contiene ulteriori dettagli.",
        "archivesOn": "Passa in archivio il",
        "deletesOn": "Eliminata il"
      },
      "unlistedModel": {
        "linkHint": "Quale nave del catalogo è %{identifier}? Il suggerimento viene dall'export e può essere sbagliato."
      },
      "slug": "Slug",
      "inventories": {
        "source": "Origine",
        "sources": {
          "vehicle": "Nave",
          "handMade": "Creato a mano"
        }
      },
      "inventoryItems": {
        "name": "Nome",
        "category": "Categoria",
        "entryType": "Movimento",
        "quantity": "Quantità",
        "quality": "Qualità",
        "notes": "Note",
        "itemType": "Catalogo",
        "categories": {
          "commodity": "Merce",
          "component": "Componente",
          "weapon": "Arma",
          "equipment": "Equipaggiamento",
          "ammunition": "Munizioni",
          "consumable": "Consumabile",
          "other": "Altro"
        },
        "entryTypes": {
          "deposit": "Deposito",
          "withdrawal": "Prelievo"
        },
        "units": {
          "scu": "SCU",
          "units": "unità"
        }
      },
      "shipHistory": {
        "sales": "Storico delle offerte",
        "salesCount": "Offerte registrate",
        "lastSale": "Ultima offerta",
        "averageGap": "Intervallo medio",
        "days": "%{count} giorni",
        "ongoing": "In corso",
        "priceHistory": "Storico del prezzo pledge",
        "firstPriced": "Primo prezzo",
        "priceRemoved": "Prezzo rimosso",
        "wishlist": "Aggiunte alla lista dei desideri per mese",
        "patchChanges": "Modifiche della patch",
        "notRecordedYet": "Registrato solo da quando è iniziato il tracciamento, quindi una nave può non avere nulla."
      },
      "buildCompare": {
        "from": "Dalla build",
        "to": "Alla build",
        "appeared": "Comparsi",
        "vanished": "Scomparsi",
        "changed": "Modificati",
        "notRecorded": "Non registrato per una di queste build.",
        "needsTwoBuilds": "È registrata una sola build, quindi non c'è nulla con cui confrontarla.",
        "pickTwoBuilds": "Scegli due build diverse.",
        "failed": "Impossibile confrontare queste due build.",
        "andMore": "e altri %{count}",
        "catalogues": {
          "components": "Componenti",
          "equipment": "Equipaggiamento",
          "commodities": "Merci",
          "models": "Navi"
        }
      },
      "dockAccess": {
        "ramp": "Rampa",
        "lift": "Ascensore",
        "tractor_beam": "Raggio traente"
      },
      "dockTypes": {
        "vehiclepad": "Piazzola per veicoli",
        "garage": "Garage",
        "landingpad": "Piazzola di atterraggio",
        "dockingport": "Porta di attracco",
        "hangar": "Hangar",
        "cargogrid": "Griglia di carico"
      },
      "shipSizes": {
        "extra_extra_small": "Snubcraft (XXS)",
        "extra_small": "Extra piccolo (XS)",
        "small": "Piccolo (S)",
        "medium": "Medio (M)",
        "large": "Grande (L)",
        "extra_large": "Extra grande (XL)",
        "capital": "Capitale (C)"
      },
      "payouts": {
        "currency": "Valuta",
        "archived": "Archiviata",
        "activeTours": "In corso",
        "amount": "Importo",
        "description": "Descrizione",
        "entryType": "Tipo",
        "expense": "Speso",
        "income": "Guadagnato",
        "participant": "Chi",
        "notes": "Note",
        "occurredAt": "Quando",
        "paid": "Speso",
        "held": "Detiene",
        "share": "Quota",
        "net": "Saldo",
        "profit": "Profitto",
        "totalIncome": "Guadagnato",
        "totalExpenses": "Speso",
        "guest": "Ospite",
        "username": "Nome utente",
        "name": "Nome",
        "sends": "invia",
        "receives": "riceve",
        "settled": "Chiuso",
        "open": "Aperto",
        "owes": "deve",
        "isOwed": "deve ricevere",
        "even": "in pari",
        "title": "Titolo",
        "fleet": "Flotta",
        "startsAt": "Inizia il",
        "inviteLink": "Link d'invito",
        "participants": "Persone",
        "weight": "Peso",
        "shares": "quote",
        "customWeight": "Peso personalizzato",
        "preview": "Anteprima · cambia fino al saldo",
        "joinRequestPending": "Richiesta in attesa",
        "payer": "Pagatore",
        "declineReason": "Motivo",
        "review": {
          "pending": "In attesa di verifica",
          "approved": "Approvata",
          "declined": "Rifiutata"
        }
      },
      "relationships": {
        "party": "Nome",
        "since": "Dal",
        "tabs": {
          "accepted": "Attivi",
          "incoming": "In arrivo",
          "outgoing": "Inviate",
          "ignored": "Ignorate"
        },
        "user": {
          "handle": "Nome utente"
        },
        "fleet": {
          "handle": "Identificativo della flotta"
        },
        "requested": "Richiesta inviata",
        "friend": "Amici"
      },
      "blueprint": {
        "name": "Nome",
        "craftTime": "Tempo di fabbricazione",
        "slots": "Slot",
        "materials": "Materiali",
        "quality": "Qualità",
        "missionSlots": {
          "location": "luogo",
          "objects": "oggetti",
          "target": "bersaglio",
          "ship": "nave",
          "cargo": "carico",
          "rank": "grado",
          "danger": "pericolo",
          "contract": "contratto",
          "other": "variabile"
        },
        "missionSlotsHint": "I termini tra ‹parentesi angolari› vengono inseriti dal gioco quando il contratto viene offerto.",
        "atNeutral": "%{value} a Q500",
        "whatYouGet": "Cosa ottieni",
        "fromSlots": "%{count} slot",
        "factorOnly": "solo fattore — nessun valore a catalogo",
        "heldIn": "in",
        "heldOn": "su",
        "fromHangar": "Hangar",
        "makes": "Produce",
        "makesA": "Progetto di fabbricazione · produce",
        "makesUnknown": "Progetto di fabbricazione · produce qualcosa che nessun catalogo qui riporta",
        "retired": "Ritirato",
        "minQuality": "Min. %{quality}",
        "belowGate": "Sotto la soglia di questo slot — un materiale inferiore a %{quality} non ci entra.",
        "unvalued": "interessato — il gioco non indica valori",
        "noStats": "Questo slot non muove alcuna statistica — il materiale deve solo esserci.",
        "noMaterials": "I file di gioco non indicano materiali per questo progetto.",
        "setEverySlot": "Imposta tutti gli slot",
        "qualityAll": "tutti gli slot a %{quality}",
        "qualityRange": "%{from}–%{to} tra gli slot",
        "anyOf": "%{count} qualsiasi di questi %{total}",
        "scu": "%{amount} SCU",
        "pieces": "%{count}×",
        "whereItDrops": "Dove si ottiene",
        "fleetOwners": "Chi può fabbricarlo",
        "ownedByCount": "%{count} lo possiedono",
        "sourceSummary": "%{count} fonti · %{orgs} organizzazioni",
        "unattributed": "Non attribuito",
        "minPoints": "Da %{points} punti",
        "noKnownSource": "Nessuna fonte nota",
        "noSourceLead": "Nessuna missione o scenario rilascia questo progetto.",
        "noSourceBody": "I file di gioco non lo inseriscono in alcun gruppo di ricompense, quindi non c'è nulla da indicare.",
        "empty": "Nessun progetto corrisponde.",
        "craftableTypes": {
          "Component": "Componente",
          "Equipment": "Equipaggiamento",
          "Commodity": "Merce"
        },
        "alignments": {
          "lawful": "Legale",
          "neutral": "Neutrale",
          "outlaw": "Fuorilegge"
        },
        "kinds": {
          "contract": "Contratto",
          "scenario": "Scenario"
        },
        "duration": {
          "hours": "%{count} h",
          "minutes": "%{count} min",
          "seconds": "%{count} s"
        }
      },
      "gameMission": {
        "locationNamedInText": "citato nel briefing",
        "locations": "Dove si svolge",
        "locationKinds": {
          "surface": "Su un pianeta o una luna",
          "space": "Nello spazio",
          "mixed": "Pianeta, luna o spazio",
          "unknown": "Luogo sconosciuto"
        },
        "location": "Luogo",
        "cannotLand": {
          "surface": "%{ship} non può atterrare: questo contratto si svolge su un pianeta o una luna",
          "mixed": "Può portare %{ship} su un pianeta o una luna, dove non può atterrare"
        },
        "calculatedInGame": "Calcolato nel gioco",
        "blueprints": "Progetti",
        "name": "Nome",
        "org": "Offerta da",
        "offeredBy": "Offerta da",
        "offeredByUnknown": "Nessun committente indicato",
        "standing": "Reputazione",
        "kind": "Tipo",
        "kinds": {
          "career": "Carriera",
          "contract": "Singola"
        },
        "difficulty": "Difficoltà",
        "difficultyAxes": {
          "mechanicalSkill": "Abilità meccanica",
          "mentalLoad": "Carico mentale",
          "riskOfLoss": "Rischio di perdita",
          "gameKnowledge": "Conoscenza del gioco"
        },
        "alignments": {
          "lawful": "Legale",
          "neutral": "Neutrale",
          "outlaw": "Fuorilegge"
        },
        "rewards": "Ricompense",
        "rewardKinds": {
          "blueprint": "Progetti",
          "reputation": "Reputazione",
          "item": "Oggetti",
          "badge": "Distintivo",
          "currency": "Pagamento"
        },
        "oneOfASet": "uno di un gruppo",
        "briefing": "Briefing",
        "templatedNote": "Il gioco riempie le parti segnate quando assegna la missione.",
        "payoutNote": "Il gioco calcola il pagamento quando genera la missione, perciò i file ne indicano uno solo per pochi contratti.",
        "noRewards": "I file non indicano alcuna ricompensa per questa missione.",
        "unreleased": "Non nella release",
        "retired": "Ritirata"
      },
      "fleetDirectory": {
        "name": "Flotte",
        "memberCount": "Membri",
        "createdAt": "Più recenti",
        "language": "Lingua",
        "recruiting": "Recluta",
        "notRecruiting": "Non recluta",
        "roleplay": "Gioco di ruolo",
        "rsiSid": "SID %{sid}"
      },
      "tour": {
        "step": "Passo %{current} di %{total}"
      },
      "vehiclePlaque": {
        "style": "Stile",
        "styles": {
          "brass": "Ottone",
          "hud": "HUD Fleetyards",
          "gunmetal": "Canna di fucile",
          "blueprint": "Progetto di cantiere",
          "salvage": "Rottame rivettato",
          "glass": "Vetro smerigliato",
          "carbon": "Carbonio e rosso segnale",
          "walnut": "Noce e ottone",
          "neon": "Neon di Pyro",
          "manufacturer": "Stile del costruttore"
        },
        "registry": "Matricola",
        "operationsGroup": "Squadra operativa",
        "title": "Targa di dedica",
        "dedication": "Dedica",
        "launchedOn": "Data del varo",
        "launchPort": "Porto del varo",
        "affiliation": "Affiliazione"
      },
      "vehicleOverview": {
        "picture": "Immagine",
        "pictureInfo": "Mostrata al posto dell'immagine predefinita, anche nel tuo hangar pubblico e nelle flotte con cui condividi questa nave.",
        "ownPicture": "La tua immagine",
        "serial": "Numero di serie %{serial}",
        "since": "Nell'hangar dal %{date}",
        "logSummary": "%{count} voci · %{public} pubbliche",
        "cargoFill": "%{stowed} di %{capacity} SCU caricati",
        "cargoStowed": "%{stowed} SCU caricati",
        "cargoMeter": "Carico",
        "configuration": "Configurazione",
        "noPaint": "Verniciatura standard",
        "ownedPaints": "Le tue verniciature",
        "availablePaints": "Verniciature",
        "paintApplied": "%{paint}, applicata",
        "visibility": "Visibilità",
        "showPublic": "Mostra nel mio hangar pubblico",
        "showName": "Mostra il nome",
        "fleets": "In servizio con",
        "status": "Stato",
        "searchPaints": "Cerca verniciature",
        "location": "Posizione",
        "noLocation": "Non impostata",
        "noGroups": "Nessun gruppo",
        "planLoadout": "Pianifica un loadout",
        "pictureUpload": "Carica",
        "pictureGallery": "Galleria",
        "stockPicture": "Immagine predefinita"
      },
      "vehicleLog": {
        "entries": "voci del diario",
        "title": "Titolo",
        "loggedAt": "Data",
        "loggedAtPlaceholder": "Adesso",
        "body": "Voce",
        "public": "Mostra nel mio hangar pubblico",
        "publicShort": "Pubblica",
        "publicByDefault": "Le nuove voci sono pubbliche",
        "filters": {
          "all": "Tutte",
          "public": "Pubbliche",
          "private": "Private"
        },
        "entryCount": {
          "one": "%{count} voce",
          "other": "%{count} voci"
        },
        "privateShort": "Privata",
        "stats": "Il diario",
        "statsEntries": "Voci",
        "statsPublic": "Pubbliche",
        "statsSince": "Dal"
      }
    }
  }
}
